/* @generated from adl module kachemedia.specsheet.db */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_db from './../../common/db';
import * as common_strings from './../../common/strings';
import * as kachemedia_specsheet_artworkspec from './artworkspec';
import * as kachemedia_specsheet_common from './common';

/**
 * A sequential version number
 */
export type Version = number;

const Version_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A sequential version number\n"}],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"primitive","value":"Word32"},"parameters":[]}}},"name":"Version","version":{"kind":"nothing"}}};

export const snVersion: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"Version"};

export function texprVersion(): ADL.ATypeExpr<Version> {
  return {value : {typeRef : {kind: "reference", value : snVersion}, parameters : []}};
}

export interface OrganisationConfig {
  hideJobId: boolean;
}

export function makeOrganisationConfig(
  input: {
    hideJobId: boolean,
  }
): OrganisationConfig {
  return {
    hideJobId: input.hideJobId,
  };
}

const OrganisationConfig_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"hideJobId","default":{"kind":"nothing"},"name":"hideJobId","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"OrganisationConfig","version":{"kind":"nothing"}}};

export const snOrganisationConfig: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"OrganisationConfig"};

export function texprOrganisationConfig(): ADL.ATypeExpr<OrganisationConfig> {
  return {value : {typeRef : {kind: "reference", value : snOrganisationConfig}, parameters : []}};
}

export interface Organisation {
  /**
   * Organisation name
   */
  name: common_strings.StringNE;
  /**
   * Organisation logo S3 hash
   */
  logo: kachemedia_specsheet_common.ImageHash;
  isActive: boolean;
  config: (OrganisationConfig|null);
  created: common.Instant;
  updated: common.Instant;
}

export function makeOrganisation(
  input: {
    name: common_strings.StringNE,
    logo: kachemedia_specsheet_common.ImageHash,
    isActive?: boolean,
    config?: (OrganisationConfig|null),
    created: common.Instant,
    updated: common.Instant,
  }
): Organisation {
  return {
    name: input.name,
    logo: input.logo,
    isActive: input.isActive === undefined ? true : input.isActive,
    config: input.config === undefined ? null : input.config,
    created: input.created,
    updated: input.updated,
  };
}

const Organisation_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["name"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Organisation name\n"}],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Organisation logo S3 hash\n"}],"serializedName":"logo","default":{"kind":"nothing"},"name":"logo","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.common","name":"ImageHash"}},"parameters":[]}},{"annotations":[],"serializedName":"isActive","default":{"kind":"just","value":true},"name":"isActive","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"config","default":{"kind":"just","value":null},"name":"config","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"OrganisationConfig"}},"parameters":[]}]}},{"annotations":[],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updated","default":{"kind":"nothing"},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"Organisation","version":{"kind":"nothing"}}};

export const snOrganisation: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"Organisation"};

export function texprOrganisation(): ADL.ATypeExpr<Organisation> {
  return {value : {typeRef : {kind: "reference", value : snOrganisation}, parameters : []}};
}

export interface Workspace {
  organisationId: common_db.DbKey<Organisation>;
  name: common_strings.StringNE;
  logo: kachemedia_specsheet_common.ImageHash;
  isActive: boolean;
  created: common.Instant;
  updated: common.Instant;
}

export function makeWorkspace(
  input: {
    organisationId: common_db.DbKey<Organisation>,
    name: common_strings.StringNE,
    logo: kachemedia_specsheet_common.ImageHash,
    isActive: boolean,
    created: common.Instant,
    updated: common.Instant,
  }
): Workspace {
  return {
    organisationId: input.organisationId,
    name: input.name,
    logo: input.logo,
    isActive: input.isActive,
    created: input.created,
    updated: input.updated,
  };
}

const Workspace_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["organisationId"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"organisationId","default":{"kind":"nothing"},"name":"organisationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Organisation"}},"parameters":[]}]}},{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"logo","default":{"kind":"nothing"},"name":"logo","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.common","name":"ImageHash"}},"parameters":[]}},{"annotations":[],"serializedName":"isActive","default":{"kind":"nothing"},"name":"isActive","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updated","default":{"kind":"nothing"},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"Workspace","version":{"kind":"nothing"}}};

export const snWorkspace: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"Workspace"};

export function texprWorkspace(): ADL.ATypeExpr<Workspace> {
  return {value : {typeRef : {kind: "reference", value : snWorkspace}, parameters : []}};
}

export enum OrgMemberStatus {
  Pending,
  Active,
  Deactivated,
  Removed,
}

const OrgMemberStatus_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"Pending","default":{"kind":"nothing"},"name":"Pending","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Active","default":{"kind":"nothing"},"name":"Active","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Deactivated","default":{"kind":"nothing"},"name":"Deactivated","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Removed","default":{"kind":"nothing"},"name":"Removed","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"OrgMemberStatus","version":{"kind":"nothing"}}};

export const snOrgMemberStatus: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"OrgMemberStatus"};

export function texprOrgMemberStatus(): ADL.ATypeExpr<OrgMemberStatus> {
  return {value : {typeRef : {kind: "reference", value : snOrgMemberStatus}, parameters : []}};
}

/**
 * An app user details
 */
export interface AppUser {
  /**
   * Name
   */
  name: common_strings.StringNE;
  /**
   * Last name
   */
  lastName: common_strings.StringNE;
  /**
   * Email
   */
  email: common_strings.EmailAddress;
  /**
   * User profile picture S3 hash
   */
  profilePic: kachemedia_specsheet_common.ImageHash;
  created: common.Instant;
  updated: common.Instant;
}

export function makeAppUser(
  input: {
    name: common_strings.StringNE,
    lastName: common_strings.StringNE,
    email: common_strings.EmailAddress,
    profilePic: kachemedia_specsheet_common.ImageHash,
    created: common.Instant,
    updated: common.Instant,
  }
): AppUser {
  return {
    name: input.name,
    lastName: input.lastName,
    email: input.email,
    profilePic: input.profilePic,
    created: input.created,
    updated: input.updated,
  };
}

const AppUser_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["email"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"An app user details\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Name\n"}],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Last name\n"}],"serializedName":"lastName","default":{"kind":"nothing"},"name":"lastName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Email\n"}],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"EmailAddress"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"User profile picture S3 hash\n"}],"serializedName":"profilePic","default":{"kind":"nothing"},"name":"profilePic","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.common","name":"ImageHash"}},"parameters":[]}},{"annotations":[],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updated","default":{"kind":"nothing"},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"AppUser","version":{"kind":"nothing"}}};

export const snAppUser: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"AppUser"};

export function texprAppUser(): ADL.ATypeExpr<AppUser> {
  return {value : {typeRef : {kind: "reference", value : snAppUser}, parameters : []}};
}

/**
 * Fields for local (db, email, hashedPassword) login.
 */
export interface AppUserLocalLogin {
  appUserId: common_db.DbKey<AppUser>;
  /**
   * Hashed password
   */
  hashedPassword: common_strings.StringNE;
  /**
   * Secret token to validate a password reset request
   */
  passwordResetToken: (common_strings.StringNE|null);
}

export function makeAppUserLocalLogin(
  input: {
    appUserId: common_db.DbKey<AppUser>,
    hashedPassword?: common_strings.StringNE,
    passwordResetToken: (common_strings.StringNE|null),
  }
): AppUserLocalLogin {
  return {
    appUserId: input.appUserId,
    hashedPassword: input.hashedPassword === undefined ? "" : input.hashedPassword,
    passwordResetToken: input.passwordResetToken,
  };
}

const AppUserLocalLogin_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["appUserId"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Fields for local (db, email, hashedPassword) login.\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"appUserId","default":{"kind":"nothing"},"name":"appUserId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"AppUser"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Hashed password\n"}],"serializedName":"hashedPassword","default":{"kind":"just","value":""},"name":"hashedPassword","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Secret token to validate a password reset request\n"}],"serializedName":"passwordResetToken","default":{"kind":"nothing"},"name":"passwordResetToken","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}}]}},"name":"AppUserLocalLogin","version":{"kind":"nothing"}}};

export const snAppUserLocalLogin: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"AppUserLocalLogin"};

export function texprAppUserLocalLogin(): ADL.ATypeExpr<AppUserLocalLogin> {
  return {value : {typeRef : {kind: "reference", value : snAppUserLocalLogin}, parameters : []}};
}

/**
 * App user when created externally (SSO)
 */
export interface AppUserExternalLogin {
  appUserId: common_db.DbKey<AppUser>;
  provider: string;
  data: {}|null;
}

export function makeAppUserExternalLogin(
  input: {
    appUserId: common_db.DbKey<AppUser>,
    provider: string,
    data: {}|null,
  }
): AppUserExternalLogin {
  return {
    appUserId: input.appUserId,
    provider: input.provider,
    data: input.data,
  };
}

const AppUserExternalLogin_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["appUserId"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"App user when created externally (SSO)\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"appUserId","default":{"kind":"nothing"},"name":"appUserId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"AppUser"}},"parameters":[]}]}},{"annotations":[],"serializedName":"provider","default":{"kind":"nothing"},"name":"provider","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"data","default":{"kind":"nothing"},"name":"data","typeExpr":{"typeRef":{"kind":"primitive","value":"Json"},"parameters":[]}}]}},"name":"AppUserExternalLogin","version":{"kind":"nothing"}}};

export const snAppUserExternalLogin: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"AppUserExternalLogin"};

export function texprAppUserExternalLogin(): ADL.ATypeExpr<AppUserExternalLogin> {
  return {value : {typeRef : {kind: "reference", value : snAppUserExternalLogin}, parameters : []}};
}

/**
 * App internal operations member.  AppUser has access level of the app operations.
 */
export interface OperationsMember {
  appUserId: common_db.DbKey<AppUser>;
  isActive: boolean;
  masquerade: (OperationsMasquerade|null);
}

export function makeOperationsMember(
  input: {
    appUserId: common_db.DbKey<AppUser>,
    isActive?: boolean,
    masquerade?: (OperationsMasquerade|null),
  }
): OperationsMember {
  return {
    appUserId: input.appUserId,
    isActive: input.isActive === undefined ? true : input.isActive,
    masquerade: input.masquerade === undefined ? null : input.masquerade,
  };
}

const OperationsMember_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["appUserId"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"App internal operations member.  AppUser has access level of the app operations.\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"appUserId","default":{"kind":"nothing"},"name":"appUserId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"AppUser"}},"parameters":[]}]}},{"annotations":[],"serializedName":"isActive","default":{"kind":"just","value":true},"name":"isActive","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"masquerade","default":{"kind":"just","value":null},"name":"masquerade","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"OperationsMasquerade"}},"parameters":[]}]}}]}},"name":"OperationsMember","version":{"kind":"nothing"}}};

export const snOperationsMember: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"OperationsMember"};

export function texprOperationsMember(): ADL.ATypeExpr<OperationsMember> {
  return {value : {typeRef : {kind: "reference", value : snOperationsMember}, parameters : []}};
}

export interface OperationsMasquerade {
  orgId: (common_db.DbKey<Organisation>|null);
  workspaceId: (common_db.DbKey<Workspace>|null);
}

export function makeOperationsMasquerade(
  input: {
    orgId?: (common_db.DbKey<Organisation>|null),
    workspaceId?: (common_db.DbKey<Workspace>|null),
  }
): OperationsMasquerade {
  return {
    orgId: input.orgId === undefined ? null : input.orgId,
    workspaceId: input.workspaceId === undefined ? null : input.workspaceId,
  };
}

const OperationsMasquerade_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"orgId","default":{"kind":"just","value":null},"name":"orgId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Organisation"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"workspaceId","default":{"kind":"just","value":null},"name":"workspaceId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Workspace"}},"parameters":[]}]}]}}]}},"name":"OperationsMasquerade","version":{"kind":"nothing"}}};

export const snOperationsMasquerade: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"OperationsMasquerade"};

export function texprOperationsMasquerade(): ADL.ATypeExpr<OperationsMasquerade> {
  return {value : {typeRef : {kind: "reference", value : snOperationsMasquerade}, parameters : []}};
}

export enum OrganisationMemberRole {
  ADMIN,
  BASIC,
  GUEST,
}

const OrganisationMemberRole_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"ADMIN","default":{"kind":"nothing"},"name":"ADMIN","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"BASIC","default":{"kind":"nothing"},"name":"BASIC","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"GUEST","default":{"kind":"nothing"},"name":"GUEST","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"OrganisationMemberRole","version":{"kind":"nothing"}}};

export const snOrganisationMemberRole: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"OrganisationMemberRole"};

export function texprOrganisationMemberRole(): ADL.ATypeExpr<OrganisationMemberRole> {
  return {value : {typeRef : {kind: "reference", value : snOrganisationMemberRole}, parameters : []}};
}

/**
 * Organisation has many AppUser Members.  AppUser has an access level for each organisation
 */
export interface OrganisationMember {
  organisationId: common_db.DbKey<Organisation>;
  appUserId: common_db.DbKey<AppUser>;
  organisationRole: OrganisationMemberRole;
  status: OrgMemberStatus;
  created: common.Instant;
  updated: common.Instant;
}

export function makeOrganisationMember(
  input: {
    organisationId: common_db.DbKey<Organisation>,
    appUserId: common_db.DbKey<AppUser>,
    organisationRole: OrganisationMemberRole,
    status: OrgMemberStatus,
    created: common.Instant,
    updated: common.Instant,
  }
): OrganisationMember {
  return {
    organisationId: input.organisationId,
    appUserId: input.appUserId,
    organisationRole: input.organisationRole,
    status: input.status,
    created: input.created,
    updated: input.updated,
  };
}

const OrganisationMember_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["organisationId","appUserId"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Organisation has many AppUser Members.  AppUser has an access level for each organisation\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"organisationId","default":{"kind":"nothing"},"name":"organisationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Organisation"}},"parameters":[]}]}},{"annotations":[],"serializedName":"appUserId","default":{"kind":"nothing"},"name":"appUserId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"AppUser"}},"parameters":[]}]}},{"annotations":[],"serializedName":"organisationRole","default":{"kind":"nothing"},"name":"organisationRole","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"OrganisationMemberRole"}},"parameters":[]}},{"annotations":[],"serializedName":"status","default":{"kind":"nothing"},"name":"status","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"OrgMemberStatus"}},"parameters":[]}},{"annotations":[],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updated","default":{"kind":"nothing"},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"OrganisationMember","version":{"kind":"nothing"}}};

export const snOrganisationMember: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"OrganisationMember"};

export function texprOrganisationMember(): ADL.ATypeExpr<OrganisationMember> {
  return {value : {typeRef : {kind: "reference", value : snOrganisationMember}, parameters : []}};
}

export enum WorkspaceMemberRole {
  ADMIN,
  MEDIA_PLANNER,
  COLLABORATOR,
}

const WorkspaceMemberRole_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"ADMIN","default":{"kind":"nothing"},"name":"ADMIN","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"MEDIA_PLANNER","default":{"kind":"nothing"},"name":"MEDIA_PLANNER","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"COLLABORATOR","default":{"kind":"nothing"},"name":"COLLABORATOR","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"WorkspaceMemberRole","version":{"kind":"nothing"}}};

export const snWorkspaceMemberRole: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"WorkspaceMemberRole"};

export function texprWorkspaceMemberRole(): ADL.ATypeExpr<WorkspaceMemberRole> {
  return {value : {typeRef : {kind: "reference", value : snWorkspaceMemberRole}, parameters : []}};
}

/**
 * Workspace has many Org Members.   OrgMember is a member of many workspaces.   OrgMember has an access level for each workspace.
 */
export interface WorkspaceMember {
  workspaceId: common_db.DbKey<Workspace>;
  orgMemberId: common_db.DbKey<OrganisationMember>;
  workspaceRole: WorkspaceMemberRole;
  isActive: boolean;
  created: common.Instant;
  updated: common.Instant;
}

export function makeWorkspaceMember(
  input: {
    workspaceId: common_db.DbKey<Workspace>,
    orgMemberId: common_db.DbKey<OrganisationMember>,
    workspaceRole: WorkspaceMemberRole,
    isActive?: boolean,
    created: common.Instant,
    updated: common.Instant,
  }
): WorkspaceMember {
  return {
    workspaceId: input.workspaceId,
    orgMemberId: input.orgMemberId,
    workspaceRole: input.workspaceRole,
    isActive: input.isActive === undefined ? true : input.isActive,
    created: input.created,
    updated: input.updated,
  };
}

const WorkspaceMember_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["workspaceId","orgMemberId"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Workspace has many Org Members.   OrgMember is a member of many workspaces.   OrgMember has an access level for each workspace.\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"workspaceId","default":{"kind":"nothing"},"name":"workspaceId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Workspace"}},"parameters":[]}]}},{"annotations":[],"serializedName":"orgMemberId","default":{"kind":"nothing"},"name":"orgMemberId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"OrganisationMember"}},"parameters":[]}]}},{"annotations":[],"serializedName":"workspaceRole","default":{"kind":"nothing"},"name":"workspaceRole","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"WorkspaceMemberRole"}},"parameters":[]}},{"annotations":[],"serializedName":"isActive","default":{"kind":"just","value":true},"name":"isActive","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updated","default":{"kind":"nothing"},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"WorkspaceMember","version":{"kind":"nothing"}}};

export const snWorkspaceMember: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"WorkspaceMember"};

export function texprWorkspaceMember(): ADL.ATypeExpr<WorkspaceMember> {
  return {value : {typeRef : {kind: "reference", value : snWorkspaceMember}, parameters : []}};
}

export interface UserGroup {
  name: common_strings.StringNE;
  workspaceId: common_db.DbKey<Workspace>;
  logo: kachemedia_specsheet_common.ImageHash;
  isActive: boolean;
  created: common.Instant;
  updated: common.Instant;
}

export function makeUserGroup(
  input: {
    name: common_strings.StringNE,
    workspaceId: common_db.DbKey<Workspace>,
    logo: kachemedia_specsheet_common.ImageHash,
    isActive: boolean,
    created: common.Instant,
    updated: common.Instant,
  }
): UserGroup {
  return {
    name: input.name,
    workspaceId: input.workspaceId,
    logo: input.logo,
    isActive: input.isActive,
    created: input.created,
    updated: input.updated,
  };
}

const UserGroup_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"workspaceId","default":{"kind":"nothing"},"name":"workspaceId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Workspace"}},"parameters":[]}]}},{"annotations":[],"serializedName":"logo","default":{"kind":"nothing"},"name":"logo","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.common","name":"ImageHash"}},"parameters":[]}},{"annotations":[],"serializedName":"isActive","default":{"kind":"nothing"},"name":"isActive","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updated","default":{"kind":"nothing"},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"UserGroup","version":{"kind":"nothing"}}};

export const snUserGroup: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"UserGroup"};

export function texprUserGroup(): ADL.ATypeExpr<UserGroup> {
  return {value : {typeRef : {kind: "reference", value : snUserGroup}, parameters : []}};
}

export interface UserGroupMember {
  userGroupId: common_db.DbKey<UserGroup>;
  workspaceMemberId: common_db.DbKey<WorkspaceMember>;
  created: common.Instant;
  updated: common.Instant;
}

export function makeUserGroupMember(
  input: {
    userGroupId: common_db.DbKey<UserGroup>,
    workspaceMemberId: common_db.DbKey<WorkspaceMember>,
    created: common.Instant,
    updated: common.Instant,
  }
): UserGroupMember {
  return {
    userGroupId: input.userGroupId,
    workspaceMemberId: input.workspaceMemberId,
    created: input.created,
    updated: input.updated,
  };
}

const UserGroupMember_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["workspaceMemberId","userGroupId"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"userGroupId","default":{"kind":"nothing"},"name":"userGroupId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"UserGroup"}},"parameters":[]}]}},{"annotations":[],"serializedName":"workspaceMemberId","default":{"kind":"nothing"},"name":"workspaceMemberId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"WorkspaceMember"}},"parameters":[]}]}},{"annotations":[],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updated","default":{"kind":"nothing"},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"UserGroupMember","version":{"kind":"nothing"}}};

export const snUserGroupMember: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"UserGroupMember"};

export function texprUserGroupMember(): ADL.ATypeExpr<UserGroupMember> {
  return {value : {typeRef : {kind: "reference", value : snUserGroupMember}, parameters : []}};
}

/**
 * An advertisement campaign
 */
export interface Campaign {
  /**
   * Workspace id
   */
  workspaceId: common_db.DbKey<Workspace>;
  /**
   * Campaign title
   */
  title: common_strings.StringNE;
  /**
   * Campaign summary
   */
  summary: common_strings.StringNE;
  /**
   * Campaign status
   */
  status: CampaignStatus;
  /**
   * Creation date
   */
  creationDate: common.Instant;
  /**
   * Live date
   */
  liveDate: common.LocalDate;
  /**
   * End (of being live) date
   */
  endDate: (common.LocalDate|null);
  /**
   * Campaign Client
   */
  clientId: common_db.DbKey<Client>;
  /**
   * Creator or this campaign userId
   */
  creatorAppUserId: common_db.DbKey<AppUser>;
  /**
   * Last updated instant
   */
  lastUpdated: common.Instant;
  /**
   * Job number
   */
  jobNumber: string;
  /**
   * Latest (current) version number
   */
  version: Version;
  /**
   * Documents/attachments urls
   */
  documents: kachemedia_specsheet_common.UrlResource[];
  /**
   * Free text metadata
   */
  notes: kachemedia_specsheet_common.WysiwygDescendant[];
}

export function makeCampaign(
  input: {
    workspaceId: common_db.DbKey<Workspace>,
    title: common_strings.StringNE,
    summary: common_strings.StringNE,
    status: CampaignStatus,
    creationDate: common.Instant,
    liveDate: common.LocalDate,
    endDate?: (common.LocalDate|null),
    clientId: common_db.DbKey<Client>,
    creatorAppUserId: common_db.DbKey<AppUser>,
    lastUpdated: common.Instant,
    jobNumber: string,
    version: Version,
    documents?: kachemedia_specsheet_common.UrlResource[],
    notes?: kachemedia_specsheet_common.WysiwygDescendant[],
  }
): Campaign {
  return {
    workspaceId: input.workspaceId,
    title: input.title,
    summary: input.summary,
    status: input.status,
    creationDate: input.creationDate,
    liveDate: input.liveDate,
    endDate: input.endDate === undefined ? null : input.endDate,
    clientId: input.clientId,
    creatorAppUserId: input.creatorAppUserId,
    lastUpdated: input.lastUpdated,
    jobNumber: input.jobNumber,
    version: input.version,
    documents: input.documents === undefined ? [] : input.documents,
    notes: input.notes === undefined ? [] : input.notes,
  };
}

const Campaign_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"extraSql":["alter table campaign add constraint campaign_id_version_fk foreign key (id, version) references campaign_version (campaign_id, version) deferrable initially deferred;"],"withIdPrimaryKey":true,"indexes":[["workspaceId"]],"uniquenessConstraints":[["workspaceId","jobNumber"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"An advertisement campaign\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Workspace id\n"}],"serializedName":"workspaceId","default":{"kind":"nothing"},"name":"workspaceId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Workspace"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Campaign title\n"}],"serializedName":"title","default":{"kind":"nothing"},"name":"title","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Campaign summary\n"}],"serializedName":"summary","default":{"kind":"nothing"},"name":"summary","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Campaign status\n"}],"serializedName":"status","default":{"kind":"nothing"},"name":"status","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"CampaignStatus"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Creation date\n"}],"serializedName":"creationDate","default":{"kind":"nothing"},"name":"creationDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Live date\n"}],"serializedName":"liveDate","default":{"kind":"nothing"},"name":"liveDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"End (of being live) date\n"}],"serializedName":"endDate","default":{"kind":"just","value":null},"name":"endDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Campaign Client\n"}],"serializedName":"clientId","default":{"kind":"nothing"},"name":"clientId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Client"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Creator or this campaign userId\n"}],"serializedName":"creatorAppUserId","default":{"kind":"nothing"},"name":"creatorAppUserId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"AppUser"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Last updated instant\n"}],"serializedName":"lastUpdated","default":{"kind":"nothing"},"name":"lastUpdated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Job number\n"}],"serializedName":"jobNumber","default":{"kind":"nothing"},"name":"jobNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Latest (current) version number\n"}],"serializedName":"version","default":{"kind":"nothing"},"name":"version","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Version"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Documents/attachments urls\n"}],"serializedName":"documents","default":{"kind":"just","value":[]},"name":"documents","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.common","name":"UrlResource"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Free text metadata\n"}],"serializedName":"notes","default":{"kind":"just","value":[]},"name":"notes","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.common","name":"WysiwygDescendant"}},"parameters":[]}]}}]}},"name":"Campaign","version":{"kind":"nothing"}}};

export const snCampaign: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"Campaign"};

export function texprCampaign(): ADL.ATypeExpr<Campaign> {
  return {value : {typeRef : {kind: "reference", value : snCampaign}, parameters : []}};
}

/**
 * Represents an email that has been shared with the specified campaign.
 */
export interface CampaignShare {
  campaignId: common_db.DbKey<Campaign>;
  email: common_strings.EmailAddress;
}

export function makeCampaignShare(
  input: {
    campaignId: common_db.DbKey<Campaign>,
    email: common_strings.EmailAddress,
  }
): CampaignShare {
  return {
    campaignId: input.campaignId,
    email: input.email,
  };
}

const CampaignShare_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["campaignId"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents an email that has been shared with the specified campaign.\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"campaignId","default":{"kind":"nothing"},"name":"campaignId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Campaign"}},"parameters":[]}]}},{"annotations":[],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"EmailAddress"}},"parameters":[]}}]}},"name":"CampaignShare","version":{"kind":"nothing"}}};

export const snCampaignShare: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"CampaignShare"};

export function texprCampaignShare(): ADL.ATypeExpr<CampaignShare> {
  return {value : {typeRef : {kind: "reference", value : snCampaignShare}, parameters : []}};
}

/**
 * A version of a campaign (either published/locked or the currently editing latest version)
 */
export interface CampaignVersion {
  /**
   * Id of campaign associated with this version.
   */
  campaignId: common_db.DbKey<Campaign>;
  /**
   * Unique version number string (incremental)
   */
  version: Version;
  /**
   * Locked version (can't have further changes)
   */
  locked: boolean;
  /**
   * Last updated instant
   */
  lastUpdated: common.Instant;
  /**
   * Description of version, if available
   */
  message: (common_strings.StringNE|null);
  /**
   * User who published version. Null if the campaign has not been published.
   */
  userId: (common_db.DbKey<AppUser>|null);
}

export function makeCampaignVersion(
  input: {
    campaignId: common_db.DbKey<Campaign>,
    version: Version,
    locked: boolean,
    lastUpdated: common.Instant,
    message?: (common_strings.StringNE|null),
    userId: (common_db.DbKey<AppUser>|null),
  }
): CampaignVersion {
  return {
    campaignId: input.campaignId,
    version: input.version,
    locked: input.locked,
    lastUpdated: input.lastUpdated,
    message: input.message === undefined ? null : input.message,
    userId: input.userId,
  };
}

const CampaignVersion_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["campaignId","version"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A version of a campaign (either published/locked or the currently editing latest version)\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Id of campaign associated with this version.\n"}],"serializedName":"campaignId","default":{"kind":"nothing"},"name":"campaignId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Campaign"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Unique version number string (incremental)\n"}],"serializedName":"version","default":{"kind":"nothing"},"name":"version","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Version"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Locked version (can't have further changes)\n"}],"serializedName":"locked","default":{"kind":"nothing"},"name":"locked","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Last updated instant\n"}],"serializedName":"lastUpdated","default":{"kind":"nothing"},"name":"lastUpdated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Description of version, if available\n"}],"serializedName":"message","default":{"kind":"just","value":null},"name":"message","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"User who published version. Null if the campaign has not been published.\n"}],"serializedName":"userId","default":{"kind":"nothing"},"name":"userId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"AppUser"}},"parameters":[]}]}]}}]}},"name":"CampaignVersion","version":{"kind":"nothing"}}};

export const snCampaignVersion: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"CampaignVersion"};

export function texprCampaignVersion(): ADL.ATypeExpr<CampaignVersion> {
  return {value : {typeRef : {kind: "reference", value : snCampaignVersion}, parameters : []}};
}

/**
 * Relation between a campaign and a media planner user
 * Campaign user specific properties
 */
export interface CampaignUserDetails {
  /**
   * Campaign Id
   */
  campaignId: common_db.DbKey<Campaign>;
  /**
   * User Id
   */
  appUserId: common_db.DbKey<AppUser>;
  /**
   * Is the user a team member of this campaign?
   */
  isTeamMember: boolean;
  /**
   * Starred: Is this campaign starred for this user?
   */
  starred: boolean;
}

export function makeCampaignUserDetails(
  input: {
    campaignId: common_db.DbKey<Campaign>,
    appUserId: common_db.DbKey<AppUser>,
    isTeamMember?: boolean,
    starred?: boolean,
  }
): CampaignUserDetails {
  return {
    campaignId: input.campaignId,
    appUserId: input.appUserId,
    isTeamMember: input.isTeamMember === undefined ? false : input.isTeamMember,
    starred: input.starred === undefined ? false : input.starred,
  };
}

const CampaignUserDetails_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["campaignId","appUserId"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Relation between a campaign and a media planner user\nCampaign user specific properties\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Campaign Id\n"}],"serializedName":"campaignId","default":{"kind":"nothing"},"name":"campaignId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Campaign"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"User Id\n"}],"serializedName":"appUserId","default":{"kind":"nothing"},"name":"appUserId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"AppUser"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Is the user a team member of this campaign?\n"}],"serializedName":"isTeamMember","default":{"kind":"just","value":false},"name":"isTeamMember","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Starred: Is this campaign starred for this user?\n"}],"serializedName":"starred","default":{"kind":"just","value":false},"name":"starred","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"CampaignUserDetails","version":{"kind":"nothing"}}};

export const snCampaignUserDetails: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"CampaignUserDetails"};

export function texprCampaignUserDetails(): ADL.ATypeExpr<CampaignUserDetails> {
  return {value : {typeRef : {kind: "reference", value : snCampaignUserDetails}, parameters : []}};
}

export interface CampaignUserGroup {
  campaignId: common_db.DbKey<Campaign>;
  userGroupId: common_db.DbKey<UserGroup>;
  created: common.Instant;
  updated: common.Instant;
}

export function makeCampaignUserGroup(
  input: {
    campaignId: common_db.DbKey<Campaign>,
    userGroupId: common_db.DbKey<UserGroup>,
    created: common.Instant,
    updated: common.Instant,
  }
): CampaignUserGroup {
  return {
    campaignId: input.campaignId,
    userGroupId: input.userGroupId,
    created: input.created,
    updated: input.updated,
  };
}

const CampaignUserGroup_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["campaignId","userGroupId"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"campaignId","default":{"kind":"nothing"},"name":"campaignId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Campaign"}},"parameters":[]}]}},{"annotations":[],"serializedName":"userGroupId","default":{"kind":"nothing"},"name":"userGroupId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"UserGroup"}},"parameters":[]}]}},{"annotations":[],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updated","default":{"kind":"nothing"},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"CampaignUserGroup","version":{"kind":"nothing"}}};

export const snCampaignUserGroup: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"CampaignUserGroup"};

export function texprCampaignUserGroup(): ADL.ATypeExpr<CampaignUserGroup> {
  return {value : {typeRef : {kind: "reference", value : snCampaignUserGroup}, parameters : []}};
}

/**
 * The client of a campaign
 */
export interface Client {
  /**
   * Workspace this client belongs to
   */
  workspaceId: common_db.DbKey<Workspace>;
  /**
   * Client name
   */
  name: common_strings.StringNE;
  /**
   * Campaign client logo hash
   */
  logo: kachemedia_specsheet_common.ImageHash;
  isActive: boolean;
  created: common.Instant;
  updated: common.Instant;
}

export function makeClient(
  input: {
    workspaceId: common_db.DbKey<Workspace>,
    name: common_strings.StringNE,
    logo: kachemedia_specsheet_common.ImageHash,
    isActive: boolean,
    created: common.Instant,
    updated: common.Instant,
  }
): Client {
  return {
    workspaceId: input.workspaceId,
    name: input.name,
    logo: input.logo,
    isActive: input.isActive,
    created: input.created,
    updated: input.updated,
  };
}

const Client_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["workspaceId"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The client of a campaign\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Workspace this client belongs to\n"}],"serializedName":"workspaceId","default":{"kind":"nothing"},"name":"workspaceId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Workspace"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Client name\n"}],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Campaign client logo hash\n"}],"serializedName":"logo","default":{"kind":"nothing"},"name":"logo","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.common","name":"ImageHash"}},"parameters":[]}},{"annotations":[],"serializedName":"isActive","default":{"kind":"nothing"},"name":"isActive","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updated","default":{"kind":"nothing"},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"Client","version":{"kind":"nothing"}}};

export const snClient: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"Client"};

export function texprClient(): ADL.ATypeExpr<Client> {
  return {value : {typeRef : {kind: "reference", value : snClient}, parameters : []}};
}

export enum CampaignStatus {
  Active,
  Paused,
  Draft,
  Archived,
}

const CampaignStatus_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Campaign statuses\n"}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"ACTIVE"},{"v1":{"moduleName":"kachemedia.specsheet.annotations","name":"StatusLabelColor"},"v2":"green"}],"serializedName":"Active","default":{"kind":"nothing"},"name":"Active","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"PAUSED"},{"v1":{"moduleName":"kachemedia.specsheet.annotations","name":"StatusLabelColor"},"v2":"blue"}],"serializedName":"Paused","default":{"kind":"nothing"},"name":"Paused","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"DRAFT"},{"v1":{"moduleName":"kachemedia.specsheet.annotations","name":"StatusLabelColor"},"v2":"orange"}],"serializedName":"Draft","default":{"kind":"nothing"},"name":"Draft","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"ARCHIVED"},{"v1":{"moduleName":"kachemedia.specsheet.annotations","name":"StatusLabelColor"},"v2":"red"}],"serializedName":"Archived","default":{"kind":"nothing"},"name":"Archived","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"CampaignStatus","version":{"kind":"nothing"}}};

export const snCampaignStatus: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"CampaignStatus"};

export function texprCampaignStatus(): ADL.ATypeExpr<CampaignStatus> {
  return {value : {typeRef : {kind: "reference", value : snCampaignStatus}, parameters : []}};
}

/**
 * Material/creative instructions
 */
export interface MaterialInstructions {
  /**
   * Objectives e.g. role of channel or placement - awareness, consideration, conversion etc
   */
  objectives: string;
  /**
   * Creative e.g. creative name, # of creative executions, and or creative rotation
   */
  creativeRotation: string;
  /**
   * Messaging e.g. CTA or brand, product, retail, retargeting etc
   */
  messaging: string;
  /**
   * Targeting e.g. audience demo, daypart, and or context
   */
  targeting: string;
  /**
   * Free notes/additional information markdown
   */
  notes: common_strings.StringMD;
}

export function makeMaterialInstructions(
  input: {
    objectives?: string,
    creativeRotation?: string,
    messaging?: string,
    targeting?: string,
    notes?: common_strings.StringMD,
  }
): MaterialInstructions {
  return {
    objectives: input.objectives === undefined ? "" : input.objectives,
    creativeRotation: input.creativeRotation === undefined ? "" : input.creativeRotation,
    messaging: input.messaging === undefined ? "" : input.messaging,
    targeting: input.targeting === undefined ? "" : input.targeting,
    notes: input.notes === undefined ? "" : input.notes,
  };
}

const MaterialInstructions_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Material/creative instructions\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Objectives e.g. role of channel or placement - awareness, consideration, conversion etc\n"}],"serializedName":"objectives","default":{"kind":"just","value":""},"name":"objectives","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Creative e.g. creative name, # of creative executions, and or creative rotation\n"}],"serializedName":"creativeRotation","default":{"kind":"just","value":""},"name":"creativeRotation","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Messaging e.g. CTA or brand, product, retail, retargeting etc\n"}],"serializedName":"messaging","default":{"kind":"just","value":""},"name":"messaging","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Targeting e.g. audience demo, daypart, and or context\n"}],"serializedName":"targeting","default":{"kind":"just","value":""},"name":"targeting","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Free notes/additional information markdown\n"}],"serializedName":"notes","default":{"kind":"just","value":""},"name":"notes","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringMD"}},"parameters":[]}}]}},"name":"MaterialInstructions","version":{"kind":"nothing"}}};

export const snMaterialInstructions: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"MaterialInstructions"};

export function texprMaterialInstructions(): ADL.ATypeExpr<MaterialInstructions> {
  return {value : {typeRef : {kind: "reference", value : snMaterialInstructions}, parameters : []}};
}

export type BookingRef = common_strings.StringNE;

const BookingRef_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}},"name":"BookingRef","version":{"kind":"nothing"}}};

export const snBookingRef: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"BookingRef"};

export function texprBookingRef(): ADL.ATypeExpr<BookingRef> {
  return {value : {typeRef : {kind: "reference", value : snBookingRef}, parameters : []}};
}

/**
 * A tracking value to mark as belonging to an externally managed campaign.
 * All placements with the same ExtCampaignRef must be added/deleted if any are to be added/deleted
 */
export type ExtCampaignRef = common_strings.StringNE;

const ExtCampaignRef_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A tracking value to mark as belonging to an externally managed campaign.\nAll placements with the same ExtCampaignRef must be added/deleted if any are to be added/deleted\n"}],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}},"name":"ExtCampaignRef","version":{"kind":"nothing"}}};

export const snExtCampaignRef: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"ExtCampaignRef"};

export function texprExtCampaignRef(): ADL.ATypeExpr<ExtCampaignRef> {
  return {value : {typeRef : {kind: "reference", value : snExtCampaignRef}, parameters : []}};
}

/**
 * The use of a placement in a campaign
 */
export interface Booking {
  /**
   * An immutable, unique identifier for this booking across all versions of this campaign
   */
  ref: BookingRef;
  /**
   * The campaign this booking is in
   */
  campaignId: common_db.DbKey<Campaign>;
  /**
   * The campaign version
   */
  campaignVersion: Version;
  /**
   * Placement Id
   */
  placementId: common_db.DbKey<Placement>;
  /**
   * Group
   */
  groupRef: (BookingGroupRef|null);
  /**
   * Dispatch date
   */
  dispatchDate: (common.LocalDate|null);
  duration: (string|null);
  /**
   * Dispatch details (Any notes for creative agency to send creative content to)
   */
  dispatchDetails: common_strings.StringMD;
  dispatchTo: common_strings.StringMD;
  /**
   * Live date
   */
  liveDate: common.LocalDate;
  /**
   * End (of being live) date:
   */
  endDate: (common.LocalDate|null);
  /**
   * A structured note applied to a booking by the media planner for the creative agency team, if present.
   */
  materialInstructions: (MaterialInstructions|null);
  /**
   * Notes
   */
  notes: common_strings.StringMD;
  /**
   * A tracking value to mark as belonging to an externally managed campaign.
   * All placements with the same ExtCampaignRef must be added/deleted if any are to be added/deleted
   */
  extCampaignRef: (ExtCampaignRef|null);
  /**
   * When the booking was created, set to default Unix epoch time.
   */
  created: common.Instant;
  /**
   * When the booking was last updated, set to default Unix epoch time.
   */
  updated: common.Instant;
}

export function makeBooking(
  input: {
    ref: BookingRef,
    campaignId: common_db.DbKey<Campaign>,
    campaignVersion: Version,
    placementId: common_db.DbKey<Placement>,
    groupRef: (BookingGroupRef|null),
    dispatchDate: (common.LocalDate|null),
    duration?: (string|null),
    dispatchDetails?: common_strings.StringMD,
    dispatchTo?: common_strings.StringMD,
    liveDate: common.LocalDate,
    endDate?: (common.LocalDate|null),
    materialInstructions?: (MaterialInstructions|null),
    notes: common_strings.StringMD,
    extCampaignRef?: (ExtCampaignRef|null),
    created?: common.Instant,
    updated?: common.Instant,
  }
): Booking {
  return {
    ref: input.ref,
    campaignId: input.campaignId,
    campaignVersion: input.campaignVersion,
    placementId: input.placementId,
    groupRef: input.groupRef,
    dispatchDate: input.dispatchDate,
    duration: input.duration === undefined ? null : input.duration,
    dispatchDetails: input.dispatchDetails === undefined ? "" : input.dispatchDetails,
    dispatchTo: input.dispatchTo === undefined ? "" : input.dispatchTo,
    liveDate: input.liveDate,
    endDate: input.endDate === undefined ? null : input.endDate,
    materialInstructions: input.materialInstructions === undefined ? null : input.materialInstructions,
    notes: input.notes,
    extCampaignRef: input.extCampaignRef === undefined ? null : input.extCampaignRef,
    created: input.created === undefined ? 0 : input.created,
    updated: input.updated === undefined ? 0 : input.updated,
  };
}

const Booking_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"extraSql":["alter table booking add constraint booking_campaign_id_campaign_version_fk foreign key (campaign_id, campaign_version) references campaign_version (campaign_id, version)  deferrable initially deferred;","alter table booking add constraint booking_group_ref_fk foreign key (campaign_id, campaign_version, group_ref) references booking_group (campaign_id, campaign_version, ref) deferrable initially deferred;"],"withIdPrimaryKey":true,"uniquenessConstraints":[["campaignId","campaignVersion","ref"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The use of a placement in a campaign\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"An immutable, unique identifier for this booking across all versions of this campaign\n"}],"serializedName":"ref","default":{"kind":"nothing"},"name":"ref","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"BookingRef"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The campaign this booking is in\n"}],"serializedName":"campaignId","default":{"kind":"nothing"},"name":"campaignId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Campaign"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The campaign version\n"}],"serializedName":"campaignVersion","default":{"kind":"nothing"},"name":"campaignVersion","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Version"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Placement Id\n"}],"serializedName":"placementId","default":{"kind":"nothing"},"name":"placementId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Placement"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Group\n"}],"serializedName":"groupRef","default":{"kind":"nothing"},"name":"groupRef","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"BookingGroupRef"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Dispatch date\n"}],"serializedName":"dispatchDate","default":{"kind":"nothing"},"name":"dispatchDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"duration","default":{"kind":"just","value":null},"name":"duration","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Dispatch details (Any notes for creative agency to send creative content to)\n"}],"serializedName":"dispatchDetails","default":{"kind":"just","value":""},"name":"dispatchDetails","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringMD"}},"parameters":[]}},{"annotations":[],"serializedName":"dispatchTo","default":{"kind":"just","value":""},"name":"dispatchTo","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringMD"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Live date\n"}],"serializedName":"liveDate","default":{"kind":"nothing"},"name":"liveDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"End (of being live) date:\n"}],"serializedName":"endDate","default":{"kind":"just","value":null},"name":"endDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A structured note applied to a booking by the media planner for the creative agency team, if present.\n"}],"serializedName":"materialInstructions","default":{"kind":"just","value":null},"name":"materialInstructions","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"MaterialInstructions"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Notes\n"}],"serializedName":"notes","default":{"kind":"nothing"},"name":"notes","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringMD"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A tracking value to mark as belonging to an externally managed campaign.\nAll placements with the same ExtCampaignRef must be added/deleted if any are to be added/deleted\n"}],"serializedName":"extCampaignRef","default":{"kind":"just","value":null},"name":"extCampaignRef","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"ExtCampaignRef"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the booking was created, set to default Unix epoch time.\n"}],"serializedName":"created","default":{"kind":"just","value":0},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the booking was last updated, set to default Unix epoch time.\n"}],"serializedName":"updated","default":{"kind":"just","value":0},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"Booking","version":{"kind":"nothing"}}};

export const snBooking: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"Booking"};

export function texprBooking(): ADL.ATypeExpr<Booking> {
  return {value : {typeRef : {kind: "reference", value : snBooking}, parameters : []}};
}

export type BookingGroupRef = common_strings.StringNE;

const BookingGroupRef_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}},"name":"BookingGroupRef","version":{"kind":"nothing"}}};

export const snBookingGroupRef: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"BookingGroupRef"};

export function texprBookingGroupRef(): ADL.ATypeExpr<BookingGroupRef> {
  return {value : {typeRef : {kind: "reference", value : snBookingGroupRef}, parameters : []}};
}

/**
 * A group of bookings in a campaign
 */
export interface BookingGroup {
  /**
   * An immutable, unique identifier for this group across all versions of this campaign
   */
  ref: BookingGroupRef;
  /**
   * The campaign this booking is in
   */
  campaignId: common_db.DbKey<Campaign>;
  /**
   * The campaign version
   */
  campaignVersion: Version;
  /**
   * The user visible (freetext) name for the group.
   */
  name: common_strings.StringNE;
  /**
   * Hierarchy reference to parent (null: group has no parent)
   */
  parentRef: (BookingGroupRef|null);
  /**
   * Level of the hierarchy of this group
   */
  level: number;
  /**
   * When the group was created, set to default Unix epoch time.
   */
  created: common.Instant;
  /**
   * When the group was last updated, set to default Unix epoch time.
   */
  updated: common.Instant;
}

export function makeBookingGroup(
  input: {
    ref: BookingGroupRef,
    campaignId: common_db.DbKey<Campaign>,
    campaignVersion: Version,
    name: common_strings.StringNE,
    parentRef: (BookingGroupRef|null),
    level: number,
    created?: common.Instant,
    updated?: common.Instant,
  }
): BookingGroup {
  return {
    ref: input.ref,
    campaignId: input.campaignId,
    campaignVersion: input.campaignVersion,
    name: input.name,
    parentRef: input.parentRef,
    level: input.level,
    created: input.created === undefined ? 0 : input.created,
    updated: input.updated === undefined ? 0 : input.updated,
  };
}

const BookingGroup_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"extraSql":["alter table booking_group add constraint booking_group_campaign_id_campaign_version_fk foreign key (campaign_id, campaign_version) references campaign_version (campaign_id, version)  deferrable initially deferred;","alter table booking_group add constraint booking_group_parent_ref_fk foreign key (campaign_id, campaign_version, parent_ref) references booking_group (campaign_id, campaign_version, ref) deferrable initially deferred;"],"withIdPrimaryKey":true,"uniquenessConstraints":[["campaignId","campaignVersion","ref"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A group of bookings in a campaign\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"An immutable, unique identifier for this group across all versions of this campaign\n"}],"serializedName":"ref","default":{"kind":"nothing"},"name":"ref","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"BookingGroupRef"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The campaign this booking is in\n"}],"serializedName":"campaignId","default":{"kind":"nothing"},"name":"campaignId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Campaign"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The campaign version\n"}],"serializedName":"campaignVersion","default":{"kind":"nothing"},"name":"campaignVersion","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Version"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The user visible (freetext) name for the group.\n"}],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Hierarchy reference to parent (null: group has no parent)\n"}],"serializedName":"parentRef","default":{"kind":"nothing"},"name":"parentRef","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"BookingGroupRef"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Level of the hierarchy of this group\n"}],"serializedName":"level","default":{"kind":"nothing"},"name":"level","typeExpr":{"typeRef":{"kind":"primitive","value":"Word32"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the group was created, set to default Unix epoch time.\n"}],"serializedName":"created","default":{"kind":"just","value":0},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the group was last updated, set to default Unix epoch time.\n"}],"serializedName":"updated","default":{"kind":"just","value":0},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"BookingGroup","version":{"kind":"nothing"}}};

export const snBookingGroup: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"BookingGroup"};

export function texprBookingGroup(): ADL.ATypeExpr<BookingGroup> {
  return {value : {typeRef : {kind: "reference", value : snBookingGroup}, parameters : []}};
}

export enum ActionLinkActionType {
  OrganisationInvite,
  PasswordReset,
  EventCreator,
}

const ActionLinkActionType_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"OrganisationInvite","default":{"kind":"nothing"},"name":"OrganisationInvite","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"PasswordReset","default":{"kind":"nothing"},"name":"PasswordReset","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"EventCreator","default":{"kind":"nothing"},"name":"EventCreator","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"ActionLinkActionType","version":{"kind":"nothing"}}};

export const snActionLinkActionType: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"ActionLinkActionType"};

export function texprActionLinkActionType(): ADL.ATypeExpr<ActionLinkActionType> {
  return {value : {typeRef : {kind: "reference", value : snActionLinkActionType}, parameters : []}};
}

export interface ActionLink {
  organisationId: (common_db.DbKey<Organisation>|null);
  appUserId: common_db.DbKey<AppUser>;
  createdByUserId: (common_db.DbKey<AppUser>|null);
  orgMemberId: (common_db.DbKey<OrganisationMember>|null);
  workspaceMemberId: (common_db.DbKey<WorkspaceMember>|null);
  token: common_strings.StringNE;
  actionType: ActionLinkActionType;
  created: common.Instant;
  updated: common.Instant;
  lastActivationDate: (common.Instant|null);
  validFrom: (common.Instant|null);
  validTill: (common.Instant|null);
  usagesLeft: (number|null);
  isActive: boolean;
}

export function makeActionLink(
  input: {
    organisationId: (common_db.DbKey<Organisation>|null),
    appUserId: common_db.DbKey<AppUser>,
    createdByUserId: (common_db.DbKey<AppUser>|null),
    orgMemberId: (common_db.DbKey<OrganisationMember>|null),
    workspaceMemberId: (common_db.DbKey<WorkspaceMember>|null),
    token: common_strings.StringNE,
    actionType: ActionLinkActionType,
    created: common.Instant,
    updated: common.Instant,
    lastActivationDate: (common.Instant|null),
    validFrom: (common.Instant|null),
    validTill: (common.Instant|null),
    usagesLeft: (number|null),
    isActive?: boolean,
  }
): ActionLink {
  return {
    organisationId: input.organisationId,
    appUserId: input.appUserId,
    createdByUserId: input.createdByUserId,
    orgMemberId: input.orgMemberId,
    workspaceMemberId: input.workspaceMemberId,
    token: input.token,
    actionType: input.actionType,
    created: input.created,
    updated: input.updated,
    lastActivationDate: input.lastActivationDate,
    validFrom: input.validFrom,
    validTill: input.validTill,
    usagesLeft: input.usagesLeft,
    isActive: input.isActive === undefined ? true : input.isActive,
  };
}

const ActionLink_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["appUserId","token"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"organisationId","default":{"kind":"nothing"},"name":"organisationId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Organisation"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"appUserId","default":{"kind":"nothing"},"name":"appUserId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"AppUser"}},"parameters":[]}]}},{"annotations":[],"serializedName":"createdByUserId","default":{"kind":"nothing"},"name":"createdByUserId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"AppUser"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"orgMemberId","default":{"kind":"nothing"},"name":"orgMemberId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"OrganisationMember"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"workspaceMemberId","default":{"kind":"nothing"},"name":"workspaceMemberId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"WorkspaceMember"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"token","default":{"kind":"nothing"},"name":"token","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"actionType","default":{"kind":"nothing"},"name":"actionType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"ActionLinkActionType"}},"parameters":[]}},{"annotations":[],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updated","default":{"kind":"nothing"},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"lastActivationDate","default":{"kind":"nothing"},"name":"lastActivationDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}]}},{"annotations":[],"serializedName":"validFrom","default":{"kind":"nothing"},"name":"validFrom","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}]}},{"annotations":[],"serializedName":"validTill","default":{"kind":"nothing"},"name":"validTill","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}]}},{"annotations":[],"serializedName":"usagesLeft","default":{"kind":"nothing"},"name":"usagesLeft","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}]}},{"annotations":[],"serializedName":"isActive","default":{"kind":"just","value":true},"name":"isActive","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"ActionLink","version":{"kind":"nothing"}}};

export const snActionLink: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"ActionLink"};

export function texprActionLink(): ADL.ATypeExpr<ActionLink> {
  return {value : {typeRef : {kind: "reference", value : snActionLink}, parameters : []}};
}

export interface ChangedValue<T> {
  before: T;
  after: T;
}

export function makeChangedValue<T>(
  input: {
    before: T,
    after: T,
  }
): ChangedValue<T> {
  return {
    before: input.before,
    after: input.after,
  };
}

const ChangedValue_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":["T"],"fields":[{"annotations":[],"serializedName":"before","default":{"kind":"nothing"},"name":"before","typeExpr":{"typeRef":{"kind":"typeParam","value":"T"},"parameters":[]}},{"annotations":[],"serializedName":"after","default":{"kind":"nothing"},"name":"after","typeExpr":{"typeRef":{"kind":"typeParam","value":"T"},"parameters":[]}}]}},"name":"ChangedValue","version":{"kind":"nothing"}}};

export const snChangedValue: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"ChangedValue"};

export function texprChangedValue<T>(texprT : ADL.ATypeExpr<T>): ADL.ATypeExpr<ChangedValue<T>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "kachemedia.specsheet.db",name : "ChangedValue"}}, parameters : [texprT.value]}};
}

export interface BookingGroupRefName {
  ref: BookingGroupRef;
  name: common_strings.StringNE;
}

export function makeBookingGroupRefName(
  input: {
    ref: BookingGroupRef,
    name: common_strings.StringNE,
  }
): BookingGroupRefName {
  return {
    ref: input.ref,
    name: input.name,
  };
}

const BookingGroupRefName_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"ref","default":{"kind":"nothing"},"name":"ref","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"BookingGroupRef"}},"parameters":[]}},{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"BookingGroupRefName","version":{"kind":"nothing"}}};

export const snBookingGroupRefName: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"BookingGroupRefName"};

export function texprBookingGroupRefName(): ADL.ATypeExpr<BookingGroupRefName> {
  return {value : {typeRef : {kind: "reference", value : snBookingGroupRefName}, parameters : []}};
}

export interface CampaignUpdatedValues {
  campaignTitleChanged: (ChangedValue<common_strings.StringNE>|null);
  liveDateChanged: (ChangedValue<common.LocalDate>|null);
  endDateChanged: (ChangedValue<(common.LocalDate|null)>|null);
  documentsChanged: (ChangedValue<kachemedia_specsheet_common.UrlResource[]>|null);
  notesChanged: (ChangedValue<kachemedia_specsheet_common.WysiwygDescendant[]>|null);
}

export function makeCampaignUpdatedValues(
  input: {
    campaignTitleChanged?: (ChangedValue<common_strings.StringNE>|null),
    liveDateChanged?: (ChangedValue<common.LocalDate>|null),
    endDateChanged?: (ChangedValue<(common.LocalDate|null)>|null),
    documentsChanged?: (ChangedValue<kachemedia_specsheet_common.UrlResource[]>|null),
    notesChanged?: (ChangedValue<kachemedia_specsheet_common.WysiwygDescendant[]>|null),
  }
): CampaignUpdatedValues {
  return {
    campaignTitleChanged: input.campaignTitleChanged === undefined ? null : input.campaignTitleChanged,
    liveDateChanged: input.liveDateChanged === undefined ? null : input.liveDateChanged,
    endDateChanged: input.endDateChanged === undefined ? null : input.endDateChanged,
    documentsChanged: input.documentsChanged === undefined ? null : input.documentsChanged,
    notesChanged: input.notesChanged === undefined ? null : input.notesChanged,
  };
}

const CampaignUpdatedValues_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"campaignTitleChanged","default":{"kind":"just","value":null},"name":"campaignTitleChanged","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"ChangedValue"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"liveDateChanged","default":{"kind":"just","value":null},"name":"liveDateChanged","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"ChangedValue"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"endDateChanged","default":{"kind":"just","value":null},"name":"endDateChanged","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"ChangedValue"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}]}]}},{"annotations":[],"serializedName":"documentsChanged","default":{"kind":"just","value":null},"name":"documentsChanged","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"ChangedValue"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.common","name":"UrlResource"}},"parameters":[]}]}]}]}},{"annotations":[],"serializedName":"notesChanged","default":{"kind":"just","value":null},"name":"notesChanged","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"ChangedValue"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.common","name":"WysiwygDescendant"}},"parameters":[]}]}]}]}}]}},"name":"CampaignUpdatedValues","version":{"kind":"nothing"}}};

export const snCampaignUpdatedValues: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"CampaignUpdatedValues"};

export function texprCampaignUpdatedValues(): ADL.ATypeExpr<CampaignUpdatedValues> {
  return {value : {typeRef : {kind: "reference", value : snCampaignUpdatedValues}, parameters : []}};
}

/**
 * Possible updates to a Booking
 */
export interface BookingUpdatedValues {
  groupChanged: (ChangedValue<(BookingGroupRefName|null)>|null);
  dispatchDateChanged: (ChangedValue<(common.LocalDate|null)>|null);
  dispatchDetailsChanged: (ChangedValue<common_strings.StringMD>|null);
  dispatchToChanged: (ChangedValue<common_strings.StringMD>|null);
  durationChanged: (ChangedValue<(string|null)>|null);
  liveDateChanged: (ChangedValue<common.LocalDate>|null);
  endDateChanged: (ChangedValue<(common.LocalDate|null)>|null);
  materialInstructionsChanged: (ChangedValue<(MaterialInstructions|null)>|null);
  notesChanged: (ChangedValue<common_strings.StringMD>|null);
}

export function makeBookingUpdatedValues(
  input: {
    groupChanged?: (ChangedValue<(BookingGroupRefName|null)>|null),
    dispatchDateChanged?: (ChangedValue<(common.LocalDate|null)>|null),
    dispatchDetailsChanged?: (ChangedValue<common_strings.StringMD>|null),
    dispatchToChanged?: (ChangedValue<common_strings.StringMD>|null),
    durationChanged?: (ChangedValue<(string|null)>|null),
    liveDateChanged?: (ChangedValue<common.LocalDate>|null),
    endDateChanged?: (ChangedValue<(common.LocalDate|null)>|null),
    materialInstructionsChanged?: (ChangedValue<(MaterialInstructions|null)>|null),
    notesChanged?: (ChangedValue<common_strings.StringMD>|null),
  }
): BookingUpdatedValues {
  return {
    groupChanged: input.groupChanged === undefined ? null : input.groupChanged,
    dispatchDateChanged: input.dispatchDateChanged === undefined ? null : input.dispatchDateChanged,
    dispatchDetailsChanged: input.dispatchDetailsChanged === undefined ? null : input.dispatchDetailsChanged,
    dispatchToChanged: input.dispatchToChanged === undefined ? null : input.dispatchToChanged,
    durationChanged: input.durationChanged === undefined ? null : input.durationChanged,
    liveDateChanged: input.liveDateChanged === undefined ? null : input.liveDateChanged,
    endDateChanged: input.endDateChanged === undefined ? null : input.endDateChanged,
    materialInstructionsChanged: input.materialInstructionsChanged === undefined ? null : input.materialInstructionsChanged,
    notesChanged: input.notesChanged === undefined ? null : input.notesChanged,
  };
}

const BookingUpdatedValues_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Possible updates to a Booking\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"groupChanged","default":{"kind":"just","value":null},"name":"groupChanged","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"ChangedValue"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"BookingGroupRefName"}},"parameters":[]}]}]}]}},{"annotations":[],"serializedName":"dispatchDateChanged","default":{"kind":"just","value":null},"name":"dispatchDateChanged","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"ChangedValue"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}]}]}},{"annotations":[],"serializedName":"dispatchDetailsChanged","default":{"kind":"just","value":null},"name":"dispatchDetailsChanged","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"ChangedValue"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringMD"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"dispatchToChanged","default":{"kind":"just","value":null},"name":"dispatchToChanged","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"ChangedValue"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringMD"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"durationChanged","default":{"kind":"just","value":null},"name":"durationChanged","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"ChangedValue"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}]}},{"annotations":[],"serializedName":"liveDateChanged","default":{"kind":"just","value":null},"name":"liveDateChanged","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"ChangedValue"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"endDateChanged","default":{"kind":"just","value":null},"name":"endDateChanged","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"ChangedValue"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}]}]}},{"annotations":[],"serializedName":"materialInstructionsChanged","default":{"kind":"just","value":null},"name":"materialInstructionsChanged","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"ChangedValue"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"MaterialInstructions"}},"parameters":[]}]}]}]}},{"annotations":[],"serializedName":"notesChanged","default":{"kind":"just","value":null},"name":"notesChanged","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"ChangedValue"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringMD"}},"parameters":[]}]}]}}]}},"name":"BookingUpdatedValues","version":{"kind":"nothing"}}};

export const snBookingUpdatedValues: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"BookingUpdatedValues"};

export function texprBookingUpdatedValues(): ADL.ATypeExpr<BookingUpdatedValues> {
  return {value : {typeRef : {kind: "reference", value : snBookingUpdatedValues}, parameters : []}};
}

export interface BookingUpdated {
  /**
   * The new resulting value
   */
  value: Booking;
  /**
   * The update (diff) against the previous value
   */
  updates: BookingUpdatedValues;
}

export function makeBookingUpdated(
  input: {
    value: Booking,
    updates: BookingUpdatedValues,
  }
): BookingUpdated {
  return {
    value: input.value,
    updates: input.updates,
  };
}

const BookingUpdated_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The new resulting value\n"}],"serializedName":"value","default":{"kind":"nothing"},"name":"value","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Booking"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The update (diff) against the previous value\n"}],"serializedName":"updates","default":{"kind":"nothing"},"name":"updates","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"BookingUpdatedValues"}},"parameters":[]}}]}},"name":"BookingUpdated","version":{"kind":"nothing"}}};

export const snBookingUpdated: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"BookingUpdated"};

export function texprBookingUpdated(): ADL.ATypeExpr<BookingUpdated> {
  return {value : {typeRef : {kind: "reference", value : snBookingUpdated}, parameters : []}};
}

export interface BookingDuplicated {
  /**
   * The pre-existing value
   */
  value: Booking;
  /**
   * The new ref
   */
  ref: BookingRef;
}

export function makeBookingDuplicated(
  input: {
    value: Booking,
    ref: BookingRef,
  }
): BookingDuplicated {
  return {
    value: input.value,
    ref: input.ref,
  };
}

const BookingDuplicated_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The pre-existing value\n"}],"serializedName":"value","default":{"kind":"nothing"},"name":"value","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Booking"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The new ref\n"}],"serializedName":"ref","default":{"kind":"nothing"},"name":"ref","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"BookingRef"}},"parameters":[]}}]}},"name":"BookingDuplicated","version":{"kind":"nothing"}}};

export const snBookingDuplicated: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"BookingDuplicated"};

export function texprBookingDuplicated(): ADL.ATypeExpr<BookingDuplicated> {
  return {value : {typeRef : {kind: "reference", value : snBookingDuplicated}, parameters : []}};
}

export interface BookingEdit_BookingDuplicated {
  kind: 'bookingDuplicated';
  value: BookingDuplicated;
}
export interface BookingEdit_BookingAdded {
  kind: 'bookingAdded';
  value: Booking;
}
export interface BookingEdit_BookingDeleted {
  kind: 'bookingDeleted';
  value: Booking;
}
export interface BookingEdit_BookingUpdated {
  kind: 'bookingUpdated';
  value: BookingUpdated;
}

/**
 * Details for an edit to a booking
 */
export type BookingEdit = BookingEdit_BookingDuplicated | BookingEdit_BookingAdded | BookingEdit_BookingDeleted | BookingEdit_BookingUpdated;

export interface BookingEditOpts {
  bookingDuplicated: BookingDuplicated;
  bookingAdded: Booking;
  bookingDeleted: Booking;
  bookingUpdated: BookingUpdated;
}

export function makeBookingEdit<K extends keyof BookingEditOpts>(kind: K, value: BookingEditOpts[K]) { return {kind, value}; }

const BookingEdit_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Details for an edit to a booking\n"}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"bookingDuplicated","default":{"kind":"nothing"},"name":"bookingDuplicated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"BookingDuplicated"}},"parameters":[]}},{"annotations":[],"serializedName":"bookingAdded","default":{"kind":"nothing"},"name":"bookingAdded","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Booking"}},"parameters":[]}},{"annotations":[],"serializedName":"bookingDeleted","default":{"kind":"nothing"},"name":"bookingDeleted","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Booking"}},"parameters":[]}},{"annotations":[],"serializedName":"bookingUpdated","default":{"kind":"nothing"},"name":"bookingUpdated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"BookingUpdated"}},"parameters":[]}}]}},"name":"BookingEdit","version":{"kind":"nothing"}}};

export const snBookingEdit: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"BookingEdit"};

export function texprBookingEdit(): ADL.ATypeExpr<BookingEdit> {
  return {value : {typeRef : {kind: "reference", value : snBookingEdit}, parameters : []}};
}

/**
 * Possible updates to a Group
 */
export interface GroupUpdatedType {
  nameChanged: (ChangedValue<common_strings.StringNE>|null);
  parentChanged: (ChangedValue<(BookingGroupRefName|null)>|null);
}

export function makeGroupUpdatedType(
  input: {
    nameChanged?: (ChangedValue<common_strings.StringNE>|null),
    parentChanged?: (ChangedValue<(BookingGroupRefName|null)>|null),
  }
): GroupUpdatedType {
  return {
    nameChanged: input.nameChanged === undefined ? null : input.nameChanged,
    parentChanged: input.parentChanged === undefined ? null : input.parentChanged,
  };
}

const GroupUpdatedType_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Possible updates to a Group\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"nameChanged","default":{"kind":"just","value":null},"name":"nameChanged","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"ChangedValue"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"parentChanged","default":{"kind":"just","value":null},"name":"parentChanged","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"ChangedValue"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"BookingGroupRefName"}},"parameters":[]}]}]}]}}]}},"name":"GroupUpdatedType","version":{"kind":"nothing"}}};

export const snGroupUpdatedType: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"GroupUpdatedType"};

export function texprGroupUpdatedType(): ADL.ATypeExpr<GroupUpdatedType> {
  return {value : {typeRef : {kind: "reference", value : snGroupUpdatedType}, parameters : []}};
}

export interface BookingGroupUpdated {
  /**
   * The new resulting value
   */
  value: BookingGroup;
  /**
   * The update (diff) against the previous value
   */
  update: GroupUpdatedType;
}

export function makeBookingGroupUpdated(
  input: {
    value: BookingGroup,
    update: GroupUpdatedType,
  }
): BookingGroupUpdated {
  return {
    value: input.value,
    update: input.update,
  };
}

const BookingGroupUpdated_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The new resulting value\n"}],"serializedName":"value","default":{"kind":"nothing"},"name":"value","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"BookingGroup"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The update (diff) against the previous value\n"}],"serializedName":"update","default":{"kind":"nothing"},"name":"update","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"GroupUpdatedType"}},"parameters":[]}}]}},"name":"BookingGroupUpdated","version":{"kind":"nothing"}}};

export const snBookingGroupUpdated: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"BookingGroupUpdated"};

export function texprBookingGroupUpdated(): ADL.ATypeExpr<BookingGroupUpdated> {
  return {value : {typeRef : {kind: "reference", value : snBookingGroupUpdated}, parameters : []}};
}

export interface BookingGroupEdit_GroupDuplicated {
  kind: 'groupDuplicated';
  value: BookingGroup;
}
export interface BookingGroupEdit_GroupAdded {
  kind: 'groupAdded';
  value: BookingGroup;
}
export interface BookingGroupEdit_GroupDeleted {
  kind: 'groupDeleted';
  value: BookingGroup;
}
export interface BookingGroupEdit_GroupUpdated {
  kind: 'groupUpdated';
  value: BookingGroupUpdated;
}

export type BookingGroupEdit = BookingGroupEdit_GroupDuplicated | BookingGroupEdit_GroupAdded | BookingGroupEdit_GroupDeleted | BookingGroupEdit_GroupUpdated;

export interface BookingGroupEditOpts {
  groupDuplicated: BookingGroup;
  groupAdded: BookingGroup;
  groupDeleted: BookingGroup;
  groupUpdated: BookingGroupUpdated;
}

export function makeBookingGroupEdit<K extends keyof BookingGroupEditOpts>(kind: K, value: BookingGroupEditOpts[K]) { return {kind, value}; }

const BookingGroupEdit_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"groupDuplicated","default":{"kind":"nothing"},"name":"groupDuplicated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"BookingGroup"}},"parameters":[]}},{"annotations":[],"serializedName":"groupAdded","default":{"kind":"nothing"},"name":"groupAdded","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"BookingGroup"}},"parameters":[]}},{"annotations":[],"serializedName":"groupDeleted","default":{"kind":"nothing"},"name":"groupDeleted","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"BookingGroup"}},"parameters":[]}},{"annotations":[],"serializedName":"groupUpdated","default":{"kind":"nothing"},"name":"groupUpdated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"BookingGroupUpdated"}},"parameters":[]}}]}},"name":"BookingGroupEdit","version":{"kind":"nothing"}}};

export const snBookingGroupEdit: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"BookingGroupEdit"};

export function texprBookingGroupEdit(): ADL.ATypeExpr<BookingGroupEdit> {
  return {value : {typeRef : {kind: "reference", value : snBookingGroupEdit}, parameters : []}};
}

/**
 * Changes within Placement itself
 */
export interface PlacementEdit {
  placementId: common_db.DbKey<Placement>;
  /**
   * Placement changes
   */
  placementChanged: ChangedValue<common_db.DbKey<PlacementSnapshot>>;
}

export function makePlacementEdit(
  input: {
    placementId: common_db.DbKey<Placement>,
    placementChanged: ChangedValue<common_db.DbKey<PlacementSnapshot>>,
  }
): PlacementEdit {
  return {
    placementId: input.placementId,
    placementChanged: input.placementChanged,
  };
}

const PlacementEdit_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Changes within Placement itself\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"placementId","default":{"kind":"nothing"},"name":"placementId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Placement"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Placement changes\n"}],"serializedName":"placementChanged","default":{"kind":"nothing"},"name":"placementChanged","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"ChangedValue"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"PlacementSnapshot"}},"parameters":[]}]}]}}]}},"name":"PlacementEdit","version":{"kind":"nothing"}}};

export const snPlacementEdit: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"PlacementEdit"};

export function texprPlacementEdit(): ADL.ATypeExpr<PlacementEdit> {
  return {value : {typeRef : {kind: "reference", value : snPlacementEdit}, parameters : []}};
}

export interface BookingPublicationEdit {
  bookingRef: BookingRef;
  publicationsChanged: ChangedValue<common_db.DbKey<Publication>[]>;
}

export function makeBookingPublicationEdit(
  input: {
    bookingRef: BookingRef,
    publicationsChanged: ChangedValue<common_db.DbKey<Publication>[]>,
  }
): BookingPublicationEdit {
  return {
    bookingRef: input.bookingRef,
    publicationsChanged: input.publicationsChanged,
  };
}

const BookingPublicationEdit_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"bookingRef","default":{"kind":"nothing"},"name":"bookingRef","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"BookingRef"}},"parameters":[]}},{"annotations":[],"serializedName":"publicationsChanged","default":{"kind":"nothing"},"name":"publicationsChanged","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"ChangedValue"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Publication"}},"parameters":[]}]}]}]}}]}},"name":"BookingPublicationEdit","version":{"kind":"nothing"}}};

export const snBookingPublicationEdit: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"BookingPublicationEdit"};

export function texprBookingPublicationEdit(): ADL.ATypeExpr<BookingPublicationEdit> {
  return {value : {typeRef : {kind: "reference", value : snBookingPublicationEdit}, parameters : []}};
}

export interface CampaignEdit_BookingEdit {
  kind: 'bookingEdit';
  value: BookingEdit;
}
export interface CampaignEdit_GroupEdit {
  kind: 'groupEdit';
  value: BookingGroupEdit;
}
export interface CampaignEdit_BookingPublicationEdit {
  kind: 'bookingPublicationEdit';
  value: BookingPublicationEdit;
}
export interface CampaignEdit_PlacementEdit {
  kind: 'placementEdit';
  value: PlacementEdit;
}
export interface CampaignEdit_CampaignDetailsEdit {
  kind: 'campaignDetailsEdit';
  value: CampaignUpdatedValues;
}

/**
 * Possible edits on the bookings, groups and placements in a campaign
 */
export type CampaignEdit = CampaignEdit_BookingEdit | CampaignEdit_GroupEdit | CampaignEdit_BookingPublicationEdit | CampaignEdit_PlacementEdit | CampaignEdit_CampaignDetailsEdit;

export interface CampaignEditOpts {
  bookingEdit: BookingEdit;
  groupEdit: BookingGroupEdit;
  bookingPublicationEdit: BookingPublicationEdit;
  placementEdit: PlacementEdit;
  campaignDetailsEdit: CampaignUpdatedValues;
}

export function makeCampaignEdit<K extends keyof CampaignEditOpts>(kind: K, value: CampaignEditOpts[K]) { return {kind, value}; }

const CampaignEdit_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Possible edits on the bookings, groups and placements in a campaign\n"}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"bookingEdit","default":{"kind":"nothing"},"name":"bookingEdit","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"BookingEdit"}},"parameters":[]}},{"annotations":[],"serializedName":"groupEdit","default":{"kind":"nothing"},"name":"groupEdit","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"BookingGroupEdit"}},"parameters":[]}},{"annotations":[],"serializedName":"bookingPublicationEdit","default":{"kind":"nothing"},"name":"bookingPublicationEdit","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"BookingPublicationEdit"}},"parameters":[]}},{"annotations":[],"serializedName":"placementEdit","default":{"kind":"nothing"},"name":"placementEdit","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"PlacementEdit"}},"parameters":[]}},{"annotations":[],"serializedName":"campaignDetailsEdit","default":{"kind":"nothing"},"name":"campaignDetailsEdit","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"CampaignUpdatedValues"}},"parameters":[]}}]}},"name":"CampaignEdit","version":{"kind":"nothing"}}};

export const snCampaignEdit: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"CampaignEdit"};

export function texprCampaignEdit(): ADL.ATypeExpr<CampaignEdit> {
  return {value : {typeRef : {kind: "reference", value : snCampaignEdit}, parameters : []}};
}

/**
 * Record of changes against a campaign.
 */
export interface CampaignChange {
  /**
   * The campaign
   */
  campaignId: common_db.DbKey<Campaign>;
  /**
   * The campaign version
   */
  campaignVersion: Version;
  /**
   * The value edited - many items for when they come as a bulk edit
   */
  edits: CampaignEdit[];
  timestamp: common.Instant;
  /**
   * Change from user (or null for internally generated changes)
   */
  userId: (common_db.DbKey<AppUser>|null);
}

export function makeCampaignChange(
  input: {
    campaignId: common_db.DbKey<Campaign>,
    campaignVersion: Version,
    edits: CampaignEdit[],
    timestamp: common.Instant,
    userId: (common_db.DbKey<AppUser>|null),
  }
): CampaignChange {
  return {
    campaignId: input.campaignId,
    campaignVersion: input.campaignVersion,
    edits: input.edits,
    timestamp: input.timestamp,
    userId: input.userId,
  };
}

const CampaignChange_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"extraSql":["alter table campaign_change add constraint campaign_change_campaign_id_campaign_version_fk foreign key (campaign_id, campaign_version) references campaign_version (campaign_id, version) deferrable initially deferred;"],"withIdPrimaryKey":true}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Record of changes against a campaign.\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The campaign\n"}],"serializedName":"campaignId","default":{"kind":"nothing"},"name":"campaignId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Campaign"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The campaign version\n"}],"serializedName":"campaignVersion","default":{"kind":"nothing"},"name":"campaignVersion","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Version"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The value edited - many items for when they come as a bulk edit\n"}],"serializedName":"edits","default":{"kind":"nothing"},"name":"edits","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"CampaignEdit"}},"parameters":[]}]}},{"annotations":[],"serializedName":"timestamp","default":{"kind":"nothing"},"name":"timestamp","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Change from user (or null for internally generated changes)\n"}],"serializedName":"userId","default":{"kind":"nothing"},"name":"userId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"AppUser"}},"parameters":[]}]}]}}]}},"name":"CampaignChange","version":{"kind":"nothing"}}};

export const snCampaignChange: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"CampaignChange"};

export function texprCampaignChange(): ADL.ATypeExpr<CampaignChange> {
  return {value : {typeRef : {kind: "reference", value : snCampaignChange}, parameters : []}};
}

/**
 * Snapshot of placements for the purpose of recording changes
 */
export interface PlacementSnapshot {
  placementId: common_db.DbKey<Placement>;
  data: Placement;
  timestamp: common.Instant;
  userId: common_db.DbKey<AppUser>;
}

export function makePlacementSnapshot(
  input: {
    placementId: common_db.DbKey<Placement>,
    data: Placement,
    timestamp: common.Instant,
    userId: common_db.DbKey<AppUser>,
  }
): PlacementSnapshot {
  return {
    placementId: input.placementId,
    data: input.data,
    timestamp: input.timestamp,
    userId: input.userId,
  };
}

const PlacementSnapshot_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Snapshot of placements for the purpose of recording changes\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"placementId","default":{"kind":"nothing"},"name":"placementId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Placement"}},"parameters":[]}]}},{"annotations":[],"serializedName":"data","default":{"kind":"nothing"},"name":"data","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Placement"}},"parameters":[]}},{"annotations":[],"serializedName":"timestamp","default":{"kind":"nothing"},"name":"timestamp","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"userId","default":{"kind":"nothing"},"name":"userId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"AppUser"}},"parameters":[]}]}}]}},"name":"PlacementSnapshot","version":{"kind":"nothing"}}};

export const snPlacementSnapshot: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"PlacementSnapshot"};

export function texprPlacementSnapshot(): ADL.ATypeExpr<PlacementSnapshot> {
  return {value : {typeRef : {kind: "reference", value : snPlacementSnapshot}, parameters : []}};
}

/**
 * A media publisher
 */
export interface Publisher {
  /**
   * Name
   */
  name: common_strings.StringNE;
  /**
   * Where this publisher was inputted from.
   */
  sourceType: SourceType;
  /**
   * Publisher logo
   */
  logo: (kachemedia_specsheet_common.DataOrigin|null);
}

export function makePublisher(
  input: {
    name: common_strings.StringNE,
    sourceType?: SourceType,
    logo?: (kachemedia_specsheet_common.DataOrigin|null),
  }
): Publisher {
  return {
    name: input.name,
    sourceType: input.sourceType === undefined ? 0 : input.sourceType,
    logo: input.logo === undefined ? null : input.logo,
  };
}

const Publisher_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["name"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A media publisher\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Name\n"}],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Where this publisher was inputted from.\n"}],"serializedName":"sourceType","default":{"kind":"just","value":"admin"},"name":"sourceType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"SourceType"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Publisher logo\n"}],"serializedName":"logo","default":{"kind":"just","value":null},"name":"logo","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.common","name":"DataOrigin"}},"parameters":[]}]}}]}},"name":"Publisher","version":{"kind":"nothing"}}};

export const snPublisher: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"Publisher"};

export function texprPublisher(): ADL.ATypeExpr<Publisher> {
  return {value : {typeRef : {kind: "reference", value : snPublisher}, parameters : []}};
}

/**
 * A media publication
 */
export interface Publication {
  /**
   * Name
   */
  name: common_strings.StringNE;
  /**
   * Where this publisher was inputted from.
   */
  sourceType: SourceType;
  /**
   * Publisher of this publication
   */
  publisherId: common_db.DbKey<Publisher>;
  /**
   * Publication logo
   */
  logo: (kachemedia_specsheet_common.DataOrigin|null);
}

export function makePublication(
  input: {
    name: common_strings.StringNE,
    sourceType?: SourceType,
    publisherId: common_db.DbKey<Publisher>,
    logo?: (kachemedia_specsheet_common.DataOrigin|null),
  }
): Publication {
  return {
    name: input.name,
    sourceType: input.sourceType === undefined ? 0 : input.sourceType,
    publisherId: input.publisherId,
    logo: input.logo === undefined ? null : input.logo,
  };
}

const Publication_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["publisherId","name"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A media publication\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Name\n"}],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Where this publisher was inputted from.\n"}],"serializedName":"sourceType","default":{"kind":"just","value":"admin"},"name":"sourceType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"SourceType"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Publisher of this publication\n"}],"serializedName":"publisherId","default":{"kind":"nothing"},"name":"publisherId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Publisher"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Publication logo\n"}],"serializedName":"logo","default":{"kind":"just","value":null},"name":"logo","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.common","name":"DataOrigin"}},"parameters":[]}]}}]}},"name":"Publication","version":{"kind":"nothing"}}};

export const snPublication: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"Publication"};

export function texprPublication(): ADL.ATypeExpr<Publication> {
  return {value : {typeRef : {kind: "reference", value : snPublication}, parameters : []}};
}

export interface Desktop {
}

export function makeDesktop(
  _input: {
  }
): Desktop {
  return {
  };
}

const Desktop_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[]}},"name":"Desktop","version":{"kind":"nothing"}}};

export const snDesktop: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"Desktop"};

export function texprDesktop(): ADL.ATypeExpr<Desktop> {
  return {value : {typeRef : {kind: "reference", value : snDesktop}, parameters : []}};
}

export interface Tablet {
}

export function makeTablet(
  _input: {
  }
): Tablet {
  return {
  };
}

const Tablet_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[]}},"name":"Tablet","version":{"kind":"nothing"}}};

export const snTablet: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"Tablet"};

export function texprTablet(): ADL.ATypeExpr<Tablet> {
  return {value : {typeRef : {kind: "reference", value : snTablet}, parameters : []}};
}

export interface Mobile {
}

export function makeMobile(
  _input: {
  }
): Mobile {
  return {
  };
}

const Mobile_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[]}},"name":"Mobile","version":{"kind":"nothing"}}};

export const snMobile: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"Mobile"};

export function texprMobile(): ADL.ATypeExpr<Mobile> {
  return {value : {typeRef : {kind: "reference", value : snMobile}, parameters : []}};
}

export interface ConnectedTv {
}

export function makeConnectedTv(
  _input: {
  }
): ConnectedTv {
  return {
  };
}

const ConnectedTv_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[]}},"name":"ConnectedTv","version":{"kind":"nothing"}}};

export const snConnectedTv: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"ConnectedTv"};

export function texprConnectedTv(): ADL.ATypeExpr<ConnectedTv> {
  return {value : {typeRef : {kind: "reference", value : snConnectedTv}, parameters : []}};
}

export interface Device {
  desktop: (Desktop|null);
  tablet: (Tablet|null);
  mobile: (Mobile|null);
  connectedTv: (ConnectedTv|null);
}

export function makeDevice(
  input: {
    desktop?: (Desktop|null),
    tablet?: (Tablet|null),
    mobile?: (Mobile|null),
    connectedTv?: (ConnectedTv|null),
  }
): Device {
  return {
    desktop: input.desktop === undefined ? null : input.desktop,
    tablet: input.tablet === undefined ? null : input.tablet,
    mobile: input.mobile === undefined ? null : input.mobile,
    connectedTv: input.connectedTv === undefined ? null : input.connectedTv,
  };
}

const Device_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Desktop"}],"serializedName":"desktop","default":{"kind":"just","value":null},"name":"desktop","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Desktop"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Tablet"}],"serializedName":"tablet","default":{"kind":"just","value":null},"name":"tablet","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Tablet"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Mobile"}],"serializedName":"mobile","default":{"kind":"just","value":null},"name":"mobile","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Mobile"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Connected TV"}],"serializedName":"connectedTv","default":{"kind":"just","value":null},"name":"connectedTv","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"ConnectedTv"}},"parameters":[]}]}}]}},"name":"Device","version":{"kind":"nothing"}}};

export const snDevice: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"Device"};

export function texprDevice(): ADL.ATypeExpr<Device> {
  return {value : {typeRef : {kind: "reference", value : snDevice}, parameters : []}};
}

export enum PlacementCategory {
  AUDIO,
  RADIO,
  BROADCAST,
  BVOD,
  CINEMA,
  DISPLAY,
  NATIVE,
  ONLINE,
  DOOH,
  PRINT_OOH,
  OOH_TRANSIT,
  PRINT_MAGAZINE,
  PRINT_NEWSPAPER,
  RICHMEDIA,
  SEM,
  SOCIAL,
  VIDEO,
  LEAD_GEN_FORM,
  OTHER,
}

const PlacementCategory_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"AUDIO"}],"serializedName":"AUDIO","default":{"kind":"nothing"},"name":"AUDIO","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"RADIO"}],"serializedName":"RADIO","default":{"kind":"nothing"},"name":"RADIO","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"BROADCAST"}],"serializedName":"BROADCAST","default":{"kind":"nothing"},"name":"BROADCAST","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"BVOD"}],"serializedName":"BVOD","default":{"kind":"nothing"},"name":"BVOD","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"CINEMA"}],"serializedName":"CINEMA","default":{"kind":"nothing"},"name":"CINEMA","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"DISPLAY"}],"serializedName":"DISPLAY","default":{"kind":"nothing"},"name":"DISPLAY","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"NATIVE"}],"serializedName":"NATIVE","default":{"kind":"nothing"},"name":"NATIVE","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"ONLINE"}],"serializedName":"ONLINE","default":{"kind":"nothing"},"name":"ONLINE","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"OOH Digital (DOOH)"}],"serializedName":"DOOH","default":{"kind":"nothing"},"name":"DOOH","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"OOH Print"}],"serializedName":"PRINT_OOH","default":{"kind":"nothing"},"name":"PRINT_OOH","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"OOH Transit"}],"serializedName":"OOH_TRANSIT","default":{"kind":"nothing"},"name":"OOH_TRANSIT","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"PRINT (Magazine)"}],"serializedName":"PRINT_MAGAZINE","default":{"kind":"nothing"},"name":"PRINT_MAGAZINE","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"PRINT (Newspaper)"}],"serializedName":"PRINT_NEWSPAPER","default":{"kind":"nothing"},"name":"PRINT_NEWSPAPER","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"RICHMEDIA"}],"serializedName":"RICHMEDIA","default":{"kind":"nothing"},"name":"RICHMEDIA","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"SEM"}],"serializedName":"SEM","default":{"kind":"nothing"},"name":"SEM","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"SOCIAL"}],"serializedName":"SOCIAL","default":{"kind":"nothing"},"name":"SOCIAL","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"VIDEO"}],"serializedName":"VIDEO","default":{"kind":"nothing"},"name":"VIDEO","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"LEAD GEN FORM"}],"serializedName":"LEAD_GEN_FORM","default":{"kind":"nothing"},"name":"LEAD_GEN_FORM","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"OTHER"}],"serializedName":"OTHER","default":{"kind":"nothing"},"name":"OTHER","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"PlacementCategory","version":{"kind":"nothing"}}};

export const snPlacementCategory: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"PlacementCategory"};

export function texprPlacementCategory(): ADL.ATypeExpr<PlacementCategory> {
  return {value : {typeRef : {kind: "reference", value : snPlacementCategory}, parameters : []}};
}

/**
 * A placement from a specific publisher
 */
export interface Placement {
  /**
   * Name of the placement
   */
  name: common_strings.StringNE;
  /**
   * Description of this placement
   */
  description: kachemedia_specsheet_common.Notes;
  /**
   * Added to name to show in the Placement Summary
   */
  summary: string;
  /**
   * Added to name summary for the text search
   */
  searchContent: string;
  geolocation: string;
  device: (Device|null);
  category: PlacementCategory;
  /**
   * Publisher Id
   */
  publisherId: common_db.DbKey<Publisher>;
  /**
   * Url of original specs for this placement
   */
  originalSpecs: kachemedia_specsheet_common.UrlResource[];
  /**
   * Images of this placement
   */
  images: kachemedia_specsheet_common.UrlResource[];
  /**
   * Documents/attachments urls - eg PDF of the entire spec.
   */
  documents: kachemedia_specsheet_common.UrlResource[];
  /**
   * Location of the Placement (used for OOH)
   */
  location: (PlacementLocation|null);
  /**
   * The specifications
   */
  specifications: kachemedia_specsheet_artworkspec.Specifications;
  /**
   * Marks if this placement is a draft
   * Placements in draft will not be visible on placement search from the specsheet.
   */
  isDraft: boolean;
  /**
   * Whether the media owner has verified this placement.
   */
  isVerified: boolean;
  isTssManaged: boolean;
  isDeprecated: boolean;
  isLinkToSpec: boolean;
  deprecatedAt: (common.Instant|null);
  /**
   * When the placement is active from, if present.
   */
  activeStart: (common.LocalDate|null);
  /**
   * When the placement is active until, if present.
   */
  activeEnd: (common.LocalDate|null);
  /**
   * Distinguish between placements that are user-inputted versus inputted
   * by the media-owner/system admin.
   */
  sourceType: SourceType;
  /**
   * Media owner contact details, if available.
   */
  mediaOwnerContactDetails: (ContactDetails|null);
  /**
   * Placement can be found on any campaign?
   */
  publicSearchable: boolean;
  /**
   * Untyped general notes / properties
   */
  attributes: kachemedia_specsheet_artworkspec.Attributes;
  /**
   * Current version number
   */
  version: Version;
  /**
   * If custom: Authored by userId
   */
  authorUserId: (common_db.DbKey<AppUser>|null);
  /**
   * If custom: Authored in campaign
   */
  campaignId: (common_db.DbKey<Campaign>|null);
  /**
   * When the placement was created, set to default Unix epoch time.
   */
  created: common.Instant;
  /**
   * When the placement was last updated, set to default Unix epoch time.
   */
  updated: common.Instant;
  /**
   * When the placement was last time verified
   */
  lastVerified: (common.Instant|null);
}

export function makePlacement(
  input: {
    name: common_strings.StringNE,
    description: kachemedia_specsheet_common.Notes,
    summary?: string,
    searchContent?: string,
    geolocation?: string,
    device?: (Device|null),
    category: PlacementCategory,
    publisherId: common_db.DbKey<Publisher>,
    originalSpecs?: kachemedia_specsheet_common.UrlResource[],
    images?: kachemedia_specsheet_common.UrlResource[],
    documents?: kachemedia_specsheet_common.UrlResource[],
    location?: (PlacementLocation|null),
    specifications: kachemedia_specsheet_artworkspec.Specifications,
    isDraft?: boolean,
    isVerified?: boolean,
    isTssManaged?: boolean,
    isDeprecated?: boolean,
    isLinkToSpec?: boolean,
    deprecatedAt?: (common.Instant|null),
    activeStart?: (common.LocalDate|null),
    activeEnd?: (common.LocalDate|null),
    sourceType: SourceType,
    mediaOwnerContactDetails?: (ContactDetails|null),
    publicSearchable?: boolean,
    attributes?: kachemedia_specsheet_artworkspec.Attributes,
    version?: Version,
    authorUserId?: (common_db.DbKey<AppUser>|null),
    campaignId?: (common_db.DbKey<Campaign>|null),
    created?: common.Instant,
    updated?: common.Instant,
    lastVerified?: (common.Instant|null),
  }
): Placement {
  return {
    name: input.name,
    description: input.description,
    summary: input.summary === undefined ? "" : input.summary,
    searchContent: input.searchContent === undefined ? "" : input.searchContent,
    geolocation: input.geolocation === undefined ? "AUS" : input.geolocation,
    device: input.device === undefined ? null : input.device,
    category: input.category,
    publisherId: input.publisherId,
    originalSpecs: input.originalSpecs === undefined ? [] : input.originalSpecs,
    images: input.images === undefined ? [] : input.images,
    documents: input.documents === undefined ? [] : input.documents,
    location: input.location === undefined ? null : input.location,
    specifications: input.specifications,
    isDraft: input.isDraft === undefined ? true : input.isDraft,
    isVerified: input.isVerified === undefined ? false : input.isVerified,
    isTssManaged: input.isTssManaged === undefined ? false : input.isTssManaged,
    isDeprecated: input.isDeprecated === undefined ? false : input.isDeprecated,
    isLinkToSpec: input.isLinkToSpec === undefined ? false : input.isLinkToSpec,
    deprecatedAt: input.deprecatedAt === undefined ? null : input.deprecatedAt,
    activeStart: input.activeStart === undefined ? null : input.activeStart,
    activeEnd: input.activeEnd === undefined ? null : input.activeEnd,
    sourceType: input.sourceType,
    mediaOwnerContactDetails: input.mediaOwnerContactDetails === undefined ? null : input.mediaOwnerContactDetails,
    publicSearchable: input.publicSearchable === undefined ? true : input.publicSearchable,
    attributes: input.attributes === undefined ? [] : input.attributes,
    version: input.version === undefined ? 1 : input.version,
    authorUserId: input.authorUserId === undefined ? null : input.authorUserId,
    campaignId: input.campaignId === undefined ? null : input.campaignId,
    created: input.created === undefined ? 0 : input.created,
    updated: input.updated === undefined ? 0 : input.updated,
    lastVerified: input.lastVerified === undefined ? null : input.lastVerified,
  };
}

const Placement_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"extraSql":["","create or replace function set_updated_timestamp()","returns trigger as $trig$","begin","  new.updated = now();","  return new;","end;","$trig$ language plpgsql;","","create trigger placement_set_updated","before update on placement","for each row","execute procedure set_updated_timestamp();"],"withIdPrimaryKey":true,"indexes":[["publisherId"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A placement from a specific publisher\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Name of the placement\n"}],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Description of this placement\n"}],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.common","name":"Notes"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Added to name to show in the Placement Summary\n"}],"serializedName":"summary","default":{"kind":"just","value":""},"name":"summary","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Keywords"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Added to name summary for the text search\n"}],"serializedName":"searchContent","default":{"kind":"just","value":""},"name":"searchContent","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Geolocation e.g AUS,NZL"}],"serializedName":"geolocation","default":{"kind":"just","value":"AUS"},"name":"geolocation","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"device","default":{"kind":"just","value":null},"name":"device","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Device"}},"parameters":[]}]}},{"annotations":[],"serializedName":"category","default":{"kind":"nothing"},"name":"category","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"PlacementCategory"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Publisher Id\n"}],"serializedName":"publisherId","default":{"kind":"nothing"},"name":"publisherId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Publisher"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Original specifications"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Url of original specs for this placement\n"}],"serializedName":"originalSpecs","default":{"kind":"just","value":[]},"name":"originalSpecs","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.common","name":"UrlResource"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Images"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Images of this placement\n"}],"serializedName":"images","default":{"kind":"just","value":[]},"name":"images","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.common","name":"UrlResource"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Documents"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Documents/attachments urls - eg PDF of the entire spec.\n"}],"serializedName":"documents","default":{"kind":"just","value":[]},"name":"documents","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.common","name":"UrlResource"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Location"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Location of the Placement (used for OOH)\n"}],"serializedName":"location","default":{"kind":"just","value":null},"name":"location","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"PlacementLocation"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The specifications\n"}],"serializedName":"specifications","default":{"kind":"nothing"},"name":"specifications","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Specifications"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Draft?"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Marks if this placement is a draft\nPlacements in draft will not be visible on placement search from the specsheet.\n"}],"serializedName":"isDraft","default":{"kind":"just","value":true},"name":"isDraft","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Verified?"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Whether the media owner has verified this placement.\n"}],"serializedName":"isVerified","default":{"kind":"just","value":false},"name":"isVerified","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"TSS Managed Placement?"}],"serializedName":"isTssManaged","default":{"kind":"just","value":false},"name":"isTssManaged","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Deprecated Placement?"}],"serializedName":"isDeprecated","default":{"kind":"just","value":false},"name":"isDeprecated","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Link To Spec?"}],"serializedName":"isLinkToSpec","default":{"kind":"just","value":false},"name":"isLinkToSpec","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"When placement was deprecated"}],"serializedName":"deprecatedAt","default":{"kind":"just","value":null},"name":"deprecatedAt","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Active from?"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the placement is active from, if present.\n"}],"serializedName":"activeStart","default":{"kind":"just","value":null},"name":"activeStart","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Active until?"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the placement is active until, if present.\n"}],"serializedName":"activeEnd","default":{"kind":"just","value":null},"name":"activeEnd","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Sourced from?"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Distinguish between placements that are user-inputted versus inputted\nby the media-owner/system admin.\n"}],"serializedName":"sourceType","default":{"kind":"nothing"},"name":"sourceType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"SourceType"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Media Owner contact"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Media owner contact details, if available.\n"}],"serializedName":"mediaOwnerContactDetails","default":{"kind":"just","value":null},"name":"mediaOwnerContactDetails","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"ContactDetails"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Placement can be found on any campaign?\n"}],"serializedName":"publicSearchable","default":{"kind":"just","value":true},"name":"publicSearchable","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Attributes Table formlabel"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Untyped general notes / properties\n"}],"serializedName":"attributes","default":{"kind":"just","value":[]},"name":"attributes","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.artworkspec","name":"Attributes"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Current version number\n"}],"serializedName":"version","default":{"kind":"just","value":1},"name":"version","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Version"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"If custom: Authored by userId\n"}],"serializedName":"authorUserId","default":{"kind":"just","value":null},"name":"authorUserId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"AppUser"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"If custom: Authored in campaign\n"}],"serializedName":"campaignId","default":{"kind":"just","value":null},"name":"campaignId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Campaign"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the placement was created, set to default Unix epoch time.\n"}],"serializedName":"created","default":{"kind":"just","value":0},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the placement was last updated, set to default Unix epoch time.\n"}],"serializedName":"updated","default":{"kind":"just","value":0},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the placement was last time verified\n"}],"serializedName":"lastVerified","default":{"kind":"just","value":null},"name":"lastVerified","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}]}}]}},"name":"Placement","version":{"kind":"nothing"}}};

export const snPlacement: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"Placement"};

export function texprPlacement(): ADL.ATypeExpr<Placement> {
  return {value : {typeRef : {kind: "reference", value : snPlacement}, parameters : []}};
}

export enum SourceType {
  admin,
  mediaOwner,
  custom,
}

const SourceType_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A flag to indicate the three possible sources this data was generated from.\nThe main goal of this type is to add a way to quickly distinguish between\nnoisy data generated by the end user and (hypothetically) cleaner data generated\nby a system admin or a media owner.\n"}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Generated by a system admin.\n"}],"serializedName":"admin","default":{"kind":"nothing"},"name":"admin","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Media Owner"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Generated by the media owner.\n"}],"serializedName":"mediaOwner","default":{"kind":"nothing"},"name":"mediaOwner","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"User-generated.\n"}],"serializedName":"custom","default":{"kind":"nothing"},"name":"custom","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"SourceType","version":{"kind":"nothing"}}};

export const snSourceType: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"SourceType"};

export function texprSourceType(): ADL.ATypeExpr<SourceType> {
  return {value : {typeRef : {kind: "reference", value : snSourceType}, parameters : []}};
}

export interface ContactDetails {
  /**
   * Name of contact.
   */
  name: common_strings.StringNE;
  /**
   * Email address of contact.
   */
  emailAddress: common_strings.EmailAddress;
  notes: (kachemedia_specsheet_common.Notes|null);
}

export function makeContactDetails(
  input: {
    name: common_strings.StringNE,
    emailAddress: common_strings.EmailAddress,
    notes?: (kachemedia_specsheet_common.Notes|null),
  }
): ContactDetails {
  return {
    name: input.name,
    emailAddress: input.emailAddress,
    notes: input.notes === undefined ? null : input.notes,
  };
}

const ContactDetails_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Name of contact.\n"}],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Email address of contact.\n"}],"serializedName":"emailAddress","default":{"kind":"nothing"},"name":"emailAddress","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"EmailAddress"}},"parameters":[]}},{"annotations":[],"serializedName":"notes","default":{"kind":"just","value":null},"name":"notes","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.common","name":"Notes"}},"parameters":[]}]}}]}},"name":"ContactDetails","version":{"kind":"nothing"}}};

export const snContactDetails: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"ContactDetails"};

export function texprContactDetails(): ADL.ATypeExpr<ContactDetails> {
  return {value : {typeRef : {kind: "reference", value : snContactDetails}, parameters : []}};
}

export interface PlacementLocation {
  /**
   * Free-form location text (address parts if available)
   */
  siteNumber: (string|null);
  direction: (string|null);
  address: (common_strings.StringML|null);
  /**
   * Suburb, if present
   */
  suburb: (string|null);
  /**
   * Post code, if present
   */
  postcode: (string|null);
  /**
   * State, if present
   */
  state: (string|null);
  /**
   * Country, if present
   */
  country: (string|null);
}

export function makePlacementLocation(
  input: {
    siteNumber?: (string|null),
    direction?: (string|null),
    address?: (common_strings.StringML|null),
    suburb?: (string|null),
    postcode?: (string|null),
    state?: (string|null),
    country?: (string|null),
  }
): PlacementLocation {
  return {
    siteNumber: input.siteNumber === undefined ? null : input.siteNumber,
    direction: input.direction === undefined ? null : input.direction,
    address: input.address === undefined ? null : input.address,
    suburb: input.suburb === undefined ? null : input.suburb,
    postcode: input.postcode === undefined ? null : input.postcode,
    state: input.state === undefined ? null : input.state,
    country: input.country === undefined ? null : input.country,
  };
}

const PlacementLocation_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Site #"},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Free-form location text (address parts if available)\n"}],"serializedName":"siteNumber","default":{"kind":"just","value":null},"name":"siteNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"direction","default":{"kind":"just","value":null},"name":"direction","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"address","default":{"kind":"just","value":null},"name":"address","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringML"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Suburb, if present\n"}],"serializedName":"suburb","default":{"kind":"just","value":null},"name":"suburb","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Post code, if present\n"}],"serializedName":"postcode","default":{"kind":"just","value":null},"name":"postcode","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"State eg NSW / VIC / WA..."},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"State, if present\n"}],"serializedName":"state","default":{"kind":"just","value":null},"name":"state","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Country, if present\n"}],"serializedName":"country","default":{"kind":"just","value":null},"name":"country","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"PlacementLocation","version":{"kind":"nothing"}}};

export const snPlacementLocation: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"PlacementLocation"};

export function texprPlacementLocation(): ADL.ATypeExpr<PlacementLocation> {
  return {value : {typeRef : {kind: "reference", value : snPlacementLocation}, parameters : []}};
}

export interface PlacementPublication {
  publicationId: common_db.DbKey<Publication>;
  placementId: common_db.DbKey<Placement>;
}

export function makePlacementPublication(
  input: {
    publicationId: common_db.DbKey<Publication>,
    placementId: common_db.DbKey<Placement>,
  }
): PlacementPublication {
  return {
    publicationId: input.publicationId,
    placementId: input.placementId,
  };
}

const PlacementPublication_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["publicationId"],["placementId"]],"uniquenessConstraints":[["publicationId","placementId"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"publicationId","default":{"kind":"nothing"},"name":"publicationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Publication"}},"parameters":[]}]}},{"annotations":[],"serializedName":"placementId","default":{"kind":"nothing"},"name":"placementId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Placement"}},"parameters":[]}]}}]}},"name":"PlacementPublication","version":{"kind":"nothing"}}};

export const snPlacementPublication: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"PlacementPublication"};

export function texprPlacementPublication(): ADL.ATypeExpr<PlacementPublication> {
  return {value : {typeRef : {kind: "reference", value : snPlacementPublication}, parameters : []}};
}

export interface PlacementOrganisation {
  organisationId: common_db.DbKey<Organisation>;
  placementId: common_db.DbKey<Placement>;
}

export function makePlacementOrganisation(
  input: {
    organisationId: common_db.DbKey<Organisation>,
    placementId: common_db.DbKey<Placement>,
  }
): PlacementOrganisation {
  return {
    organisationId: input.organisationId,
    placementId: input.placementId,
  };
}

const PlacementOrganisation_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["organisationId"],["placementId"]],"uniquenessConstraints":[["organisationId","placementId"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"organisationId","default":{"kind":"nothing"},"name":"organisationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Organisation"}},"parameters":[]}]}},{"annotations":[],"serializedName":"placementId","default":{"kind":"nothing"},"name":"placementId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Placement"}},"parameters":[]}]}}]}},"name":"PlacementOrganisation","version":{"kind":"nothing"}}};

export const snPlacementOrganisation: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"PlacementOrganisation"};

export function texprPlacementOrganisation(): ADL.ATypeExpr<PlacementOrganisation> {
  return {value : {typeRef : {kind: "reference", value : snPlacementOrganisation}, parameters : []}};
}

export interface Country {
  code: common_strings.StringNE;
  name: common_strings.StringNE;
}

export function makeCountry(
  input: {
    code: common_strings.StringNE,
    name: common_strings.StringNE,
  }
): Country {
  return {
    code: input.code,
    name: input.name,
  };
}

const Country_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["code"]],"uniquenessConstraints":[["code"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"code","default":{"kind":"nothing"},"name":"code","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"Country","version":{"kind":"nothing"}}};

export const snCountry: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"Country"};

export function texprCountry(): ADL.ATypeExpr<Country> {
  return {value : {typeRef : {kind: "reference", value : snCountry}, parameters : []}};
}

export interface PlacementCountry {
  countryId: common_db.DbKey<Country>;
  placementId: common_db.DbKey<Placement>;
}

export function makePlacementCountry(
  input: {
    countryId: common_db.DbKey<Country>,
    placementId: common_db.DbKey<Placement>,
  }
): PlacementCountry {
  return {
    countryId: input.countryId,
    placementId: input.placementId,
  };
}

const PlacementCountry_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["countryId"],["placementId"]],"uniquenessConstraints":[["countryId","placementId"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"countryId","default":{"kind":"nothing"},"name":"countryId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Country"}},"parameters":[]}]}},{"annotations":[],"serializedName":"placementId","default":{"kind":"nothing"},"name":"placementId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Placement"}},"parameters":[]}]}}]}},"name":"PlacementCountry","version":{"kind":"nothing"}}};

export const snPlacementCountry: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"PlacementCountry"};

export function texprPlacementCountry(): ADL.ATypeExpr<PlacementCountry> {
  return {value : {typeRef : {kind: "reference", value : snPlacementCountry}, parameters : []}};
}

export interface BookingPublication {
  publicationId: common_db.DbKey<Publication>;
  bookingRef: BookingRef;
}

export function makeBookingPublication(
  input: {
    publicationId: common_db.DbKey<Publication>,
    bookingRef: BookingRef,
  }
): BookingPublication {
  return {
    publicationId: input.publicationId,
    bookingRef: input.bookingRef,
  };
}

const BookingPublication_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["publicationId"],["bookingRef"]],"uniquenessConstraints":[["bookingRef","publicationId"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"publicationId","default":{"kind":"nothing"},"name":"publicationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Publication"}},"parameters":[]}]}},{"annotations":[],"serializedName":"bookingRef","default":{"kind":"nothing"},"name":"bookingRef","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"BookingRef"}},"parameters":[]}}]}},"name":"BookingPublication","version":{"kind":"nothing"}}};

export const snBookingPublication: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"BookingPublication"};

export function texprBookingPublication(): ADL.ATypeExpr<BookingPublication> {
  return {value : {typeRef : {kind: "reference", value : snBookingPublication}, parameters : []}};
}

export enum NotificationCategory {
  TEAM_MEMBER_ADDED,
  EXTERNAL,
  ANNOUNCEMENT,
  TEAM_MEMBER_REMOVED,
  CAMPAIGN_SHARED,
}

const NotificationCategory_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"User Added To Campaign"}],"serializedName":"TEAM_MEMBER_ADDED","default":{"kind":"nothing"},"name":"TEAM_MEMBER_ADDED","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"External Campaign"}],"serializedName":"EXTERNAL","default":{"kind":"nothing"},"name":"EXTERNAL","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Announcement"}],"serializedName":"ANNOUNCEMENT","default":{"kind":"nothing"},"name":"ANNOUNCEMENT","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Team Member Removed"}],"serializedName":"TEAM_MEMBER_REMOVED","default":{"kind":"nothing"},"name":"TEAM_MEMBER_REMOVED","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"common.ui","name":"FormLabel"},"v2":"Campaign Shared"}],"serializedName":"CAMPAIGN_SHARED","default":{"kind":"nothing"},"name":"CAMPAIGN_SHARED","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"NotificationCategory","version":{"kind":"nothing"}}};

export const snNotificationCategory: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"NotificationCategory"};

export function texprNotificationCategory(): ADL.ATypeExpr<NotificationCategory> {
  return {value : {typeRef : {kind: "reference", value : snNotificationCategory}, parameters : []}};
}

export interface Notification {
  userId: (common_db.DbKey<AppUser>|null);
  campaignId: (common_db.DbKey<Campaign>|null);
  workspaceId: (common_db.DbKey<Workspace>|null);
  organisationId: (common_db.DbKey<Organisation>|null);
  initiatingUserId: (common_db.DbKey<AppUser>|null);
  subject: string;
  messageText: common_strings.StringNE;
  formattedMessage: (kachemedia_specsheet_common.WysiwygDescendant[]|null);
  structuredNotification: (StructuredNotification|null);
  category: NotificationCategory;
  created: common.Instant;
  updated: common.Instant;
}

export function makeNotification(
  input: {
    userId?: (common_db.DbKey<AppUser>|null),
    campaignId?: (common_db.DbKey<Campaign>|null),
    workspaceId?: (common_db.DbKey<Workspace>|null),
    organisationId?: (common_db.DbKey<Organisation>|null),
    initiatingUserId?: (common_db.DbKey<AppUser>|null),
    subject: string,
    messageText: common_strings.StringNE,
    formattedMessage?: (kachemedia_specsheet_common.WysiwygDescendant[]|null),
    structuredNotification?: (StructuredNotification|null),
    category: NotificationCategory,
    created?: common.Instant,
    updated?: common.Instant,
  }
): Notification {
  return {
    userId: input.userId === undefined ? null : input.userId,
    campaignId: input.campaignId === undefined ? null : input.campaignId,
    workspaceId: input.workspaceId === undefined ? null : input.workspaceId,
    organisationId: input.organisationId === undefined ? null : input.organisationId,
    initiatingUserId: input.initiatingUserId === undefined ? null : input.initiatingUserId,
    subject: input.subject,
    messageText: input.messageText,
    formattedMessage: input.formattedMessage === undefined ? null : input.formattedMessage,
    structuredNotification: input.structuredNotification === undefined ? null : input.structuredNotification,
    category: input.category,
    created: input.created === undefined ? 0 : input.created,
    updated: input.updated === undefined ? 0 : input.updated,
  };
}

const Notification_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["userId"],["campaignId"],["workspaceId"],["organisationId"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"userId","default":{"kind":"just","value":null},"name":"userId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"AppUser"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"campaignId","default":{"kind":"just","value":null},"name":"campaignId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Campaign"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"workspaceId","default":{"kind":"just","value":null},"name":"workspaceId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Workspace"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"organisationId","default":{"kind":"just","value":null},"name":"organisationId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Organisation"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"initiatingUserId","default":{"kind":"just","value":null},"name":"initiatingUserId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"AppUser"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"subject","default":{"kind":"nothing"},"name":"subject","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"messageText","default":{"kind":"nothing"},"name":"messageText","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"formattedMessage","default":{"kind":"just","value":null},"name":"formattedMessage","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.common","name":"WysiwygDescendant"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"structuredNotification","default":{"kind":"just","value":null},"name":"structuredNotification","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"StructuredNotification"}},"parameters":[]}]}},{"annotations":[],"serializedName":"category","default":{"kind":"nothing"},"name":"category","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"NotificationCategory"}},"parameters":[]}},{"annotations":[],"serializedName":"created","default":{"kind":"just","value":0},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updated","default":{"kind":"just","value":0},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"Notification","version":{"kind":"nothing"}}};

export const snNotification: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"Notification"};

export function texprNotification(): ADL.ATypeExpr<Notification> {
  return {value : {typeRef : {kind: "reference", value : snNotification}, parameters : []}};
}

export interface StructuredNotification_Ext {
  kind: 'ext';
  value: ExtNotification;
}

export type StructuredNotification = StructuredNotification_Ext;

export interface StructuredNotificationOpts {
  ext: ExtNotification;
}

export function makeStructuredNotification<K extends keyof StructuredNotificationOpts>(kind: K, value: StructuredNotificationOpts[K]) { return {kind, value}; }

const StructuredNotification_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"ext","default":{"kind":"nothing"},"name":"ext","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"ExtNotification"}},"parameters":[]}}]}},"name":"StructuredNotification","version":{"kind":"nothing"}}};

export const snStructuredNotification: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"StructuredNotification"};

export function texprStructuredNotification(): ADL.ATypeExpr<StructuredNotification> {
  return {value : {typeRef : {kind: "reference", value : snStructuredNotification}, parameters : []}};
}

export interface ExtNotification {
  placementsUpdated: PlacementIdName[];
  placementsAdded: PlacementIdName[];
  placementsDeleted: PlacementIdName[];
  extCampaignMediaOwner: (common_strings.StringNE|null);
  extCampaignsChanged: (common_strings.StringNE|null);
}

export function makeExtNotification(
  input: {
    placementsUpdated: PlacementIdName[],
    placementsAdded: PlacementIdName[],
    placementsDeleted: PlacementIdName[],
    extCampaignMediaOwner: (common_strings.StringNE|null),
    extCampaignsChanged: (common_strings.StringNE|null),
  }
): ExtNotification {
  return {
    placementsUpdated: input.placementsUpdated,
    placementsAdded: input.placementsAdded,
    placementsDeleted: input.placementsDeleted,
    extCampaignMediaOwner: input.extCampaignMediaOwner,
    extCampaignsChanged: input.extCampaignsChanged,
  };
}

const ExtNotification_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"placementsUpdated","default":{"kind":"nothing"},"name":"placementsUpdated","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"PlacementIdName"}},"parameters":[]}]}},{"annotations":[],"serializedName":"placementsAdded","default":{"kind":"nothing"},"name":"placementsAdded","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"PlacementIdName"}},"parameters":[]}]}},{"annotations":[],"serializedName":"placementsDeleted","default":{"kind":"nothing"},"name":"placementsDeleted","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"PlacementIdName"}},"parameters":[]}]}},{"annotations":[],"serializedName":"extCampaignMediaOwner","default":{"kind":"nothing"},"name":"extCampaignMediaOwner","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"extCampaignsChanged","default":{"kind":"nothing"},"name":"extCampaignsChanged","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}}]}},"name":"ExtNotification","version":{"kind":"nothing"}}};

export const snExtNotification: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"ExtNotification"};

export function texprExtNotification(): ADL.ATypeExpr<ExtNotification> {
  return {value : {typeRef : {kind: "reference", value : snExtNotification}, parameters : []}};
}

export interface PlacementIdName {
  placementId: common_db.DbKey<Placement>;
  /**
   * Name of the placement
   */
  name: common_strings.StringNE;
}

export function makePlacementIdName(
  input: {
    placementId: common_db.DbKey<Placement>,
    name: common_strings.StringNE,
  }
): PlacementIdName {
  return {
    placementId: input.placementId,
    name: input.name,
  };
}

const PlacementIdName_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"placementId","default":{"kind":"nothing"},"name":"placementId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Placement"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Name of the placement\n"}],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"PlacementIdName","version":{"kind":"nothing"}}};

export const snPlacementIdName: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"PlacementIdName"};

export function texprPlacementIdName(): ADL.ATypeExpr<PlacementIdName> {
  return {value : {typeRef : {kind: "reference", value : snPlacementIdName}, parameters : []}};
}

export interface NotificationStatus {
  userId: common_db.DbKey<AppUser>;
  notificationId: common_db.DbKey<Notification>;
  isRead: boolean;
  created: common.Instant;
  updated: common.Instant;
}

export function makeNotificationStatus(
  input: {
    userId: common_db.DbKey<AppUser>,
    notificationId: common_db.DbKey<Notification>,
    isRead: boolean,
    created?: common.Instant,
    updated?: common.Instant,
  }
): NotificationStatus {
  return {
    userId: input.userId,
    notificationId: input.notificationId,
    isRead: input.isRead,
    created: input.created === undefined ? 0 : input.created,
    updated: input.updated === undefined ? 0 : input.updated,
  };
}

const NotificationStatus_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["notificationId"],["userId"]],"uniquenessConstraints":[["notificationId","userId"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"userId","default":{"kind":"nothing"},"name":"userId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"AppUser"}},"parameters":[]}]}},{"annotations":[],"serializedName":"notificationId","default":{"kind":"nothing"},"name":"notificationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Notification"}},"parameters":[]}]}},{"annotations":[],"serializedName":"isRead","default":{"kind":"nothing"},"name":"isRead","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"created","default":{"kind":"just","value":0},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updated","default":{"kind":"just","value":0},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"NotificationStatus","version":{"kind":"nothing"}}};

export const snNotificationStatus: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"NotificationStatus"};

export function texprNotificationStatus(): ADL.ATypeExpr<NotificationStatus> {
  return {value : {typeRef : {kind: "reference", value : snNotificationStatus}, parameters : []}};
}

export enum CampaignStandardColumns {
  PLACEMENT_INFO,
  STATUS,
  CHANNEL,
  DISPATCH_DATE,
  DISPATCH_DETAILS,
  LIVE_DATE,
  END_DATE,
  CREATIVE,
  NOTES,
}

const CampaignStandardColumns_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"PLACEMENT_INFO","default":{"kind":"nothing"},"name":"PLACEMENT_INFO","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"STATUS","default":{"kind":"nothing"},"name":"STATUS","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"CHANNEL","default":{"kind":"nothing"},"name":"CHANNEL","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"DISPATCH_DATE","default":{"kind":"nothing"},"name":"DISPATCH_DATE","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"DISPATCH_DETAILS","default":{"kind":"nothing"},"name":"DISPATCH_DETAILS","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"LIVE_DATE","default":{"kind":"nothing"},"name":"LIVE_DATE","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"END_DATE","default":{"kind":"nothing"},"name":"END_DATE","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"CREATIVE","default":{"kind":"nothing"},"name":"CREATIVE","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"NOTES","default":{"kind":"nothing"},"name":"NOTES","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"CampaignStandardColumns","version":{"kind":"nothing"}}};

export const snCampaignStandardColumns: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"CampaignStandardColumns"};

export function texprCampaignStandardColumns(): ADL.ATypeExpr<CampaignStandardColumns> {
  return {value : {typeRef : {kind: "reference", value : snCampaignStandardColumns}, parameters : []}};
}

/**
 * External bookings (JCD)
 */
export interface ExtBooking {
  created: common.Instant;
  updated: common.Instant;
  publisherId: common_db.DbKey<Publisher>;
  placementId: common_db.DbKey<Placement>;
  extCampaignId: common_db.DbKey<ExtCampaign>;
  importType: common_strings.StringNE;
  data: {}|null;
  isActive: boolean;
}

export function makeExtBooking(
  input: {
    created: common.Instant,
    updated: common.Instant,
    publisherId: common_db.DbKey<Publisher>,
    placementId: common_db.DbKey<Placement>,
    extCampaignId: common_db.DbKey<ExtCampaign>,
    importType: common_strings.StringNE,
    data: {}|null,
    isActive?: boolean,
  }
): ExtBooking {
  return {
    created: input.created,
    updated: input.updated,
    publisherId: input.publisherId,
    placementId: input.placementId,
    extCampaignId: input.extCampaignId,
    importType: input.importType,
    data: input.data,
    isActive: input.isActive === undefined ? true : input.isActive,
  };
}

const ExtBooking_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"External bookings (JCD)\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updated","default":{"kind":"nothing"},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"publisherId","default":{"kind":"nothing"},"name":"publisherId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Publisher"}},"parameters":[]}]}},{"annotations":[],"serializedName":"placementId","default":{"kind":"nothing"},"name":"placementId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Placement"}},"parameters":[]}]}},{"annotations":[],"serializedName":"extCampaignId","default":{"kind":"nothing"},"name":"extCampaignId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"ExtCampaign"}},"parameters":[]}]}},{"annotations":[],"serializedName":"importType","default":{"kind":"nothing"},"name":"importType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"data","default":{"kind":"nothing"},"name":"data","typeExpr":{"typeRef":{"kind":"primitive","value":"Json"},"parameters":[]}},{"annotations":[],"serializedName":"isActive","default":{"kind":"just","value":true},"name":"isActive","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"ExtBooking","version":{"kind":"nothing"}}};

export const snExtBooking: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"ExtBooking"};

export function texprExtBooking(): ADL.ATypeExpr<ExtBooking> {
  return {value : {typeRef : {kind: "reference", value : snExtBooking}, parameters : []}};
}

/**
 * External bookings change
 */
export interface ExtBookingChange {
  data: {}|null;
  importType: common_strings.StringNE;
  created: common.Instant;
  updated: common.Instant;
  extBookingId: common_db.DbKey<ExtBooking>;
}

export function makeExtBookingChange(
  input: {
    data: {}|null,
    importType: common_strings.StringNE,
    created: common.Instant,
    updated: common.Instant,
    extBookingId: common_db.DbKey<ExtBooking>,
  }
): ExtBookingChange {
  return {
    data: input.data,
    importType: input.importType,
    created: input.created,
    updated: input.updated,
    extBookingId: input.extBookingId,
  };
}

const ExtBookingChange_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"External bookings change\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"data","default":{"kind":"nothing"},"name":"data","typeExpr":{"typeRef":{"kind":"primitive","value":"Json"},"parameters":[]}},{"annotations":[],"serializedName":"importType","default":{"kind":"nothing"},"name":"importType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updated","default":{"kind":"nothing"},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"extBookingId","default":{"kind":"nothing"},"name":"extBookingId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"ExtBooking"}},"parameters":[]}]}}]}},"name":"ExtBookingChange","version":{"kind":"nothing"}}};

export const snExtBookingChange: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"ExtBookingChange"};

export function texprExtBookingChange(): ADL.ATypeExpr<ExtBookingChange> {
  return {value : {typeRef : {kind: "reference", value : snExtBookingChange}, parameters : []}};
}

/**
 * External campaigns (JCD)
 */
export interface ExtCampaign {
  created: common.Instant;
  updated: common.Instant;
  publisherId: common_db.DbKey<Publisher>;
  title: common_strings.StringNE;
  clientTitle: common_strings.StringNE;
  data: ({}|null|null);
  isActive: boolean;
}

export function makeExtCampaign(
  input: {
    created: common.Instant,
    updated: common.Instant,
    publisherId: common_db.DbKey<Publisher>,
    title: common_strings.StringNE,
    clientTitle: common_strings.StringNE,
    data?: ({}|null|null),
    isActive?: boolean,
  }
): ExtCampaign {
  return {
    created: input.created,
    updated: input.updated,
    publisherId: input.publisherId,
    title: input.title,
    clientTitle: input.clientTitle,
    data: input.data === undefined ? null : input.data,
    isActive: input.isActive === undefined ? true : input.isActive,
  };
}

const ExtCampaign_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"External campaigns (JCD)\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updated","default":{"kind":"nothing"},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"publisherId","default":{"kind":"nothing"},"name":"publisherId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Publisher"}},"parameters":[]}]}},{"annotations":[],"serializedName":"title","default":{"kind":"nothing"},"name":"title","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"clientTitle","default":{"kind":"nothing"},"name":"clientTitle","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"data","default":{"kind":"just","value":null},"name":"data","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Json"},"parameters":[]}]}},{"annotations":[],"serializedName":"isActive","default":{"kind":"just","value":true},"name":"isActive","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"ExtCampaign","version":{"kind":"nothing"}}};

export const snExtCampaign: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"ExtCampaign"};

export function texprExtCampaign(): ADL.ATypeExpr<ExtCampaign> {
  return {value : {typeRef : {kind: "reference", value : snExtCampaign}, parameters : []}};
}

/**
 * External campaign claims (JCD)
 */
export interface ExtCampaignClaim {
  created: common.Instant;
  updated: common.Instant;
  extCampaignId: common_db.DbKey<ExtCampaign>;
  campaignId: common_db.DbKey<Campaign>;
  isActive: boolean;
}

export function makeExtCampaignClaim(
  input: {
    created: common.Instant,
    updated: common.Instant,
    extCampaignId: common_db.DbKey<ExtCampaign>,
    campaignId: common_db.DbKey<Campaign>,
    isActive?: boolean,
  }
): ExtCampaignClaim {
  return {
    created: input.created,
    updated: input.updated,
    extCampaignId: input.extCampaignId,
    campaignId: input.campaignId,
    isActive: input.isActive === undefined ? true : input.isActive,
  };
}

const ExtCampaignClaim_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"External campaign claims (JCD)\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updated","default":{"kind":"nothing"},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"extCampaignId","default":{"kind":"nothing"},"name":"extCampaignId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"ExtCampaign"}},"parameters":[]}]}},{"annotations":[],"serializedName":"campaignId","default":{"kind":"nothing"},"name":"campaignId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Campaign"}},"parameters":[]}]}},{"annotations":[],"serializedName":"isActive","default":{"kind":"just","value":true},"name":"isActive","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"ExtCampaignClaim","version":{"kind":"nothing"}}};

export const snExtCampaignClaim: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"ExtCampaignClaim"};

export function texprExtCampaignClaim(): ADL.ATypeExpr<ExtCampaignClaim> {
  return {value : {typeRef : {kind: "reference", value : snExtCampaignClaim}, parameters : []}};
}

/**
 * History of external import events
 */
export interface ExtImportEvent {
  importType: common_strings.StringNE;
  created: common.Instant;
  updated: common.Instant;
  /**
   * we should store file links here, but not doing that at the moment
   */
  files: {}|null;
}

export function makeExtImportEvent(
  input: {
    importType: common_strings.StringNE,
    created: common.Instant,
    updated: common.Instant,
    files: {}|null,
  }
): ExtImportEvent {
  return {
    importType: input.importType,
    created: input.created,
    updated: input.updated,
    files: input.files,
  };
}

const ExtImportEvent_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"History of external import events\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"importType","default":{"kind":"nothing"},"name":"importType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updated","default":{"kind":"nothing"},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"we should store file links here, but not doing that at the moment\n"}],"serializedName":"files","default":{"kind":"nothing"},"name":"files","typeExpr":{"typeRef":{"kind":"primitive","value":"Json"},"parameters":[]}}]}},"name":"ExtImportEvent","version":{"kind":"nothing"}}};

export const snExtImportEvent: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"ExtImportEvent"};

export function texprExtImportEvent(): ADL.ATypeExpr<ExtImportEvent> {
  return {value : {typeRef : {kind: "reference", value : snExtImportEvent}, parameters : []}};
}

/**
 * Publication Group
 */
export interface PublicationGroup {
  created: common.Instant;
  updated: common.Instant;
  publisherId: common_db.DbKey<Publisher>;
  label: common_strings.StringNE;
}

export function makePublicationGroup(
  input: {
    created: common.Instant,
    updated: common.Instant,
    publisherId: common_db.DbKey<Publisher>,
    label: common_strings.StringNE,
  }
): PublicationGroup {
  return {
    created: input.created,
    updated: input.updated,
    publisherId: input.publisherId,
    label: input.label,
  };
}

const PublicationGroup_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Publication Group\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updated","default":{"kind":"nothing"},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"publisherId","default":{"kind":"nothing"},"name":"publisherId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Publisher"}},"parameters":[]}]}},{"annotations":[],"serializedName":"label","default":{"kind":"nothing"},"name":"label","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"PublicationGroup","version":{"kind":"nothing"}}};

export const snPublicationGroup: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"PublicationGroup"};

export function texprPublicationGroup(): ADL.ATypeExpr<PublicationGroup> {
  return {value : {typeRef : {kind: "reference", value : snPublicationGroup}, parameters : []}};
}

/**
 * Publication Group Member
 */
export interface PublicationGroupMember {
  created: common.Instant;
  updated: common.Instant;
  publicationId: common_db.DbKey<Publication>;
  publicationGroupId: common_db.DbKey<PublicationGroup>;
}

export function makePublicationGroupMember(
  input: {
    created: common.Instant,
    updated: common.Instant,
    publicationId: common_db.DbKey<Publication>,
    publicationGroupId: common_db.DbKey<PublicationGroup>,
  }
): PublicationGroupMember {
  return {
    created: input.created,
    updated: input.updated,
    publicationId: input.publicationId,
    publicationGroupId: input.publicationGroupId,
  };
}

const PublicationGroupMember_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Publication Group Member\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updated","default":{"kind":"nothing"},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"publicationId","default":{"kind":"nothing"},"name":"publicationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Publication"}},"parameters":[]}]}},{"annotations":[],"serializedName":"publicationGroupId","default":{"kind":"nothing"},"name":"publicationGroupId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"PublicationGroup"}},"parameters":[]}]}}]}},"name":"PublicationGroupMember","version":{"kind":"nothing"}}};

export const snPublicationGroupMember: ADL.ScopedName = {moduleName:"kachemedia.specsheet.db", name:"PublicationGroupMember"};

export function texprPublicationGroupMember(): ADL.ATypeExpr<PublicationGroupMember> {
  return {value : {typeRef : {kind: "reference", value : snPublicationGroupMember}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "kachemedia.specsheet.db.Version" : Version_AST,
  "kachemedia.specsheet.db.OrganisationConfig" : OrganisationConfig_AST,
  "kachemedia.specsheet.db.Organisation" : Organisation_AST,
  "kachemedia.specsheet.db.Workspace" : Workspace_AST,
  "kachemedia.specsheet.db.OrgMemberStatus" : OrgMemberStatus_AST,
  "kachemedia.specsheet.db.AppUser" : AppUser_AST,
  "kachemedia.specsheet.db.AppUserLocalLogin" : AppUserLocalLogin_AST,
  "kachemedia.specsheet.db.AppUserExternalLogin" : AppUserExternalLogin_AST,
  "kachemedia.specsheet.db.OperationsMember" : OperationsMember_AST,
  "kachemedia.specsheet.db.OperationsMasquerade" : OperationsMasquerade_AST,
  "kachemedia.specsheet.db.OrganisationMemberRole" : OrganisationMemberRole_AST,
  "kachemedia.specsheet.db.OrganisationMember" : OrganisationMember_AST,
  "kachemedia.specsheet.db.WorkspaceMemberRole" : WorkspaceMemberRole_AST,
  "kachemedia.specsheet.db.WorkspaceMember" : WorkspaceMember_AST,
  "kachemedia.specsheet.db.UserGroup" : UserGroup_AST,
  "kachemedia.specsheet.db.UserGroupMember" : UserGroupMember_AST,
  "kachemedia.specsheet.db.Campaign" : Campaign_AST,
  "kachemedia.specsheet.db.CampaignShare" : CampaignShare_AST,
  "kachemedia.specsheet.db.CampaignVersion" : CampaignVersion_AST,
  "kachemedia.specsheet.db.CampaignUserDetails" : CampaignUserDetails_AST,
  "kachemedia.specsheet.db.CampaignUserGroup" : CampaignUserGroup_AST,
  "kachemedia.specsheet.db.Client" : Client_AST,
  "kachemedia.specsheet.db.CampaignStatus" : CampaignStatus_AST,
  "kachemedia.specsheet.db.MaterialInstructions" : MaterialInstructions_AST,
  "kachemedia.specsheet.db.BookingRef" : BookingRef_AST,
  "kachemedia.specsheet.db.ExtCampaignRef" : ExtCampaignRef_AST,
  "kachemedia.specsheet.db.Booking" : Booking_AST,
  "kachemedia.specsheet.db.BookingGroupRef" : BookingGroupRef_AST,
  "kachemedia.specsheet.db.BookingGroup" : BookingGroup_AST,
  "kachemedia.specsheet.db.ActionLinkActionType" : ActionLinkActionType_AST,
  "kachemedia.specsheet.db.ActionLink" : ActionLink_AST,
  "kachemedia.specsheet.db.ChangedValue" : ChangedValue_AST,
  "kachemedia.specsheet.db.BookingGroupRefName" : BookingGroupRefName_AST,
  "kachemedia.specsheet.db.CampaignUpdatedValues" : CampaignUpdatedValues_AST,
  "kachemedia.specsheet.db.BookingUpdatedValues" : BookingUpdatedValues_AST,
  "kachemedia.specsheet.db.BookingUpdated" : BookingUpdated_AST,
  "kachemedia.specsheet.db.BookingDuplicated" : BookingDuplicated_AST,
  "kachemedia.specsheet.db.BookingEdit" : BookingEdit_AST,
  "kachemedia.specsheet.db.GroupUpdatedType" : GroupUpdatedType_AST,
  "kachemedia.specsheet.db.BookingGroupUpdated" : BookingGroupUpdated_AST,
  "kachemedia.specsheet.db.BookingGroupEdit" : BookingGroupEdit_AST,
  "kachemedia.specsheet.db.PlacementEdit" : PlacementEdit_AST,
  "kachemedia.specsheet.db.BookingPublicationEdit" : BookingPublicationEdit_AST,
  "kachemedia.specsheet.db.CampaignEdit" : CampaignEdit_AST,
  "kachemedia.specsheet.db.CampaignChange" : CampaignChange_AST,
  "kachemedia.specsheet.db.PlacementSnapshot" : PlacementSnapshot_AST,
  "kachemedia.specsheet.db.Publisher" : Publisher_AST,
  "kachemedia.specsheet.db.Publication" : Publication_AST,
  "kachemedia.specsheet.db.Desktop" : Desktop_AST,
  "kachemedia.specsheet.db.Tablet" : Tablet_AST,
  "kachemedia.specsheet.db.Mobile" : Mobile_AST,
  "kachemedia.specsheet.db.ConnectedTv" : ConnectedTv_AST,
  "kachemedia.specsheet.db.Device" : Device_AST,
  "kachemedia.specsheet.db.PlacementCategory" : PlacementCategory_AST,
  "kachemedia.specsheet.db.Placement" : Placement_AST,
  "kachemedia.specsheet.db.SourceType" : SourceType_AST,
  "kachemedia.specsheet.db.ContactDetails" : ContactDetails_AST,
  "kachemedia.specsheet.db.PlacementLocation" : PlacementLocation_AST,
  "kachemedia.specsheet.db.PlacementPublication" : PlacementPublication_AST,
  "kachemedia.specsheet.db.PlacementOrganisation" : PlacementOrganisation_AST,
  "kachemedia.specsheet.db.Country" : Country_AST,
  "kachemedia.specsheet.db.PlacementCountry" : PlacementCountry_AST,
  "kachemedia.specsheet.db.BookingPublication" : BookingPublication_AST,
  "kachemedia.specsheet.db.NotificationCategory" : NotificationCategory_AST,
  "kachemedia.specsheet.db.Notification" : Notification_AST,
  "kachemedia.specsheet.db.StructuredNotification" : StructuredNotification_AST,
  "kachemedia.specsheet.db.ExtNotification" : ExtNotification_AST,
  "kachemedia.specsheet.db.PlacementIdName" : PlacementIdName_AST,
  "kachemedia.specsheet.db.NotificationStatus" : NotificationStatus_AST,
  "kachemedia.specsheet.db.CampaignStandardColumns" : CampaignStandardColumns_AST,
  "kachemedia.specsheet.db.ExtBooking" : ExtBooking_AST,
  "kachemedia.specsheet.db.ExtBookingChange" : ExtBookingChange_AST,
  "kachemedia.specsheet.db.ExtCampaign" : ExtCampaign_AST,
  "kachemedia.specsheet.db.ExtCampaignClaim" : ExtCampaignClaim_AST,
  "kachemedia.specsheet.db.ExtImportEvent" : ExtImportEvent_AST,
  "kachemedia.specsheet.db.PublicationGroup" : PublicationGroup_AST,
  "kachemedia.specsheet.db.PublicationGroupMember" : PublicationGroupMember_AST
};
